/**
 * Clés FR absentes de lbTranslations — couverture 100 % pour la locale « lb ».
 * Valeurs FR (public luxembourgeois).
 * Généré par scripts/build-all-lang-gaps.mjs (relancer après ajout de clés en frTranslations).
 */
export const lbGapTranslations: Record<string, string> = {
  "profile.institution": "Établissement",
  "profile.institutionHint": "Votre compte LyrraOne est rattaché à cet établissement. Ce rattachement est géré par votre administrateur.",
  "profile.institutionUnknownName": "Établissement (nom indisponible)",
  "nav.codir": "CODIR",
  "nav.webinars": "Webinaires",
  "webinar.room.capacityFull": "Cette salle a atteint sa capacité maximale ({{max}} personnes connectées en même temps). Réessayez plus tard.",
  "webinar.room.speechTab": "Parole",
  "webinar.room.speechPanelHint": "Texte reconnu depuis le micro des animateurs (reconnaissance vocale du navigateur). Le nom affiché est celui de la personne qui parle.",
  "webinar.room.speechEmpty": "Quand un animateur parle avec le micro ouvert, le texte apparaît ici avec son nom. La ponctuation suit celle proposée par le navigateur.",
  "webinar.room.speechUnknownSpeaker": "Animateur",
  "webinar.room.speechPresenterActive": "Votre voix est reconnue par le navigateur et envoyée aux participants (onglet Parole).",
  "webinar.room.speechUnsupportedBrowser": "La transcription automatique des animateurs n’est pas disponible sur ce navigateur (essayez Chrome ou Edge).",
  "webinar.room.leave": "Quitter la salle",
  "webinar.room.contentFocusExpand": "Contenu sur tout l’écran",
  "webinar.room.contentFocusCollapse": "Afficher décor et intervenants",
  "webinar.room.contentFocusAriaExpand": "Agrandir la formation, le document partagé ou le partage d’écran sur tout l’espace sans fond ni intervenants",
  "webinar.room.contentFocusAriaExpandDocumentOnly": "Agrandir le document partagé (PDF ou PowerPoint) sur tout l’espace sans fond ni intervenants",
  "webinar.room.liveDocumentLabel": "Fichier (PDF ou PowerPoint)",
  "webinar.room.liveDocumentUploadChoice": "Choisir un fichier à afficher",
  "webinar.room.liveDocumentUploading": "Envoi…",
  "webinar.room.liveDocumentUploadError": "Impossible d’envoyer le fichier. Vérifiez le format (PDF ou PowerPoint) et la taille (max. 40 Mo).",
  "webinar.room.liveDocumentClose": "Retirer le document",
  "webinar.room.liveDocumentBehindScreen": "Le document reste disponible — arrêtez le partage d’écran pour le réafficher.",
  "webinar.room.waitingSharedContentExtended": "En attente du contenu partagé par l’animateur : formation catalogue, fichier (PDF ou PowerPoint) ou partage d’écran.",
  "webinar.room.waitingSharedDocumentOnly": "En attente du fichier partagé par l’animateur (PDF ou PowerPoint).",
  "webinar.room.liveDocumentShareOnlyHint": "Partagez votre présentation en PDF ou PowerPoint — c’est le seul contenu affiché aux participants.",
  "webinar.room.liveDocumentOfficeHint": "Si l’aperçu ne charge pas (HTTP local ou fichier trop lourd), ouvrez le lien ci-dessus.",
  "webinar.room.liveDocumentOpenOrDownload": "Ouvrir ou télécharger le fichier",
  "webinar.room.liveDocumentNoInlinePreview": "Ce fichier ne peut pas être affiché ici automatiquement. Ouvrez-le dans un nouvel onglet.",
  "webinar.room.liveDocumentOpenTab": "Ouvrir",
  "webinar.room.pollTab": "Sondage",
  "webinar.room.poll.regionTitle": "Sondage du webinaire",
  "webinar.room.poll.presenterHint": "Créez une question et 2 à 8 réponses. Le sondage s’affiche ici pour toute la salle ; seuls les animateurs voient les résultats en direct.",
  "webinar.room.poll.questionLabel": "Question",
  "webinar.room.poll.questionPlaceholder": "Ex. : Quel thème préférez-vous pour la suite ?",
  "webinar.room.poll.optionsLabel": "Réponses possibles",
  "webinar.room.poll.optionNumber": "Réponse",
  "webinar.room.poll.choiceLabel": "Choix",
  "webinar.room.poll.addOption": "Ajouter une réponse",
  "webinar.room.poll.removeLastOption": "Retirer la dernière",
  "webinar.room.poll.launch": "Lancer le sondage",
  "webinar.room.poll.waitingParticipant": "Aucun sondage en cours. L’animateur peut en lancer un.",
  "webinar.room.poll.voteHint": "Une réponse par personne sur le serveur : vous pouvez changer de choix en cliquant une autre option.",
  "webinar.room.poll.yourVote": "votre choix",
  "webinar.room.poll.resultsHeading": "Résultats (animateurs)",
  "webinar.room.poll.noVotesYet": "Aucun vote pour l’instant.",
  "webinar.room.poll.totalVotes": "Nombre de votes : {{n}}",
  "webinar.room.poll.closePoll": "Fermer le sondage",
  "webinar.room.contentFocusAriaCollapse": "Réafficher le décor de la scène et la colonne des intervenants",
  "webinar.room.exitDirectTitle": "Quitter le webinaire ?",
  "webinar.room.exitDirectMessage": "Vous avez ouvert cette salle depuis un lien partagé (sans passer par le tableau de bord). Vous pouvez fermer cet onglet. Si le navigateur refuse la fermeture, vous serez renvoyé vers votre espace.",
  "webinar.room.exitDirectConfirm": "Fermer l’onglet",
  "webinar.room.publicGateTitle": "Inscription au webinaire",
  "webinar.room.publicGateHint": "L’organisateur a activé l’inscription publique : indiquez votre e-mail, choisissez un mot de passe (8 caractères min.) et complétez les champs demandés.",
  "webinar.room.publicGateEmail": "E-mail",
  "webinar.room.publicGateLogin": "Identifiant",
  "webinar.room.publicGatePassword": "Mot de passe",
  "webinar.room.publicGatePasswordHintParticipant": "Première visite : inscription. Visites suivantes : même e-mail et mot de passe. Minimum 8 caractères.",
  "webinar.room.publicGateSubmit": "Entrer dans la salle",
  "webinar.room.publicGateSubmitting": "Vérification…",
  "webinar.room.publicGateDenied": "E-mail ou mot de passe incorrect.",
  "webinar.room.socketGateDenied": "Impossible de rejoindre la salle en temps réel : session d’inscription publique manquante ou expirée. Rechargez la page et reconnectez-vous avec le même e-mail et mot de passe.",
  "nav.funnels": "Funnels de vente",
  "nav.section.marketing": "Marketing & vente",
  "nav.section.institution": "Gestion & établissement",
  "nav.marketingHub": "Vue d'ensemble",
  "nav.contacts": "Contacts",
  "nav.emailMarketing": "Email marketing",
  "nav.automations": "Automatisations",
  "nav.siteWeb": "Site web",
  "nav.creatorPage": "Page créateur",
  "nav.crm": "Pipeline CRM",
  "nav.affiliate": "Affiliation",
  "nav.booking": "Calendrier",
  "nav.communities": "Communautés",
  "nav.webinarsEvergreen": "Webinaires",
  "nav.physicalProducts": "Produits physiques",
  "nav.smsMarketing": "SMS",
  "nav.section.activity": "Mon activité",
  "breadcrumb.dashboard": "Tableau de bord",
  "breadcrumb.projects": "Projets",
  "breadcrumb.eduflow": "Formations",
  "breadcrumb.learners": "Apprenants",
  "breadcrumb.analytics": "Analytiques",
  "breadcrumb.videos": "Vidéos",
  "breadcrumb.sounds": "Sons",
  "breadcrumb.images": "Images",
  "breadcrumb.documents": "Documents",
  "breadcrumb.store": "Boutique",
  "breadcrumb.help": "Aide",
  "breadcrumb.admin": "Administration",
  "breadcrumb.settings": "Paramètres",
  "breadcrumb.profile": "Profil",
  "breadcrumb.groups": "Groupes",
  "breadcrumb.branding": "Image de marque",
  "breadcrumb.landingPage": "Page d'accueil",
  "breadcrumb.webhooks": "Webhooks",
  "breadcrumb.campaigns": "Campagnes",
  "breadcrumb.competencies": "Compétences",
  "breadcrumb.compliance": "Conformité",
  "breadcrumb.reports": "Rapports",
  "breadcrumb.budget": "Budget",
  "breadcrumb.catalog": "Catalogue",
  "breadcrumb.integrations": "Intégrations",
  "breadcrumb.requests": "Demandes",
  "breadcrumb.team": "Équipe",
  "breadcrumb.reviews": "Évaluations",
  "breadcrumb.training": "Formations",
  "breadcrumb.skills": "Compétences",
  "breadcrumb.certificates": "Certificats",
  "breadcrumb.new": "Nouveau",
  "breadcrumb.edit": "Modifier",
  "breadcrumb.podcasts": "Podcasts",
  "breadcrumb.episodes": "Épisodes",
  "breadcrumb.parcours": "Parcours",
  "breadcrumb.producerAssignments": "Missions de production",
  "header.backToInstitutionAdmin": "Administration de l’établissement",
  "header.openTrainerWorkspace": "Espace formateur et création",
  "footer.a11yCenter": "Accessibilité",
  "footer.supportChat": "Aide & support",
  "btn.save": "Enregistrer",
  "role.institution_admin": "Administrateur entreprise",
  "role.resp_formation": "Responsable formation",
  "dashboard.home.greeting": "Bonjour {{name}}",
  "dashboard.home.greetingSubtitle": "Créez des formations, podcasts et parcours assistés par IA.",
  "dashboard.home.primaryCta": "Créer une formation",
  "dashboard.home.continueEditing": "Reprendre la dernière modification",
  "dashboard.home.publishRate": "Taux de publication",
  "dashboard.home.totalFormations": "Formations créées",
  "dashboard.home.uniqueLearners": "Apprenants touchés",
  "dashboard.home.calendarKicker": "Activité ce mois-ci",
  "dashboard.home.recentWork": "Dernières modifications",
  "dashboard.home.viewAll": "Tout voir",
  "dashboard.home.quickAccess": "Accès rapides",
  "dashboard.home.loading": "Chargement du tableau de bord…",
  "dashboard.home.defaultName": "formateur·rice",
  "dashboard.lo.heroTitle": "Bienvenue sur votre espace de création pédagogique.",
  "dashboard.lo.heroSubtitle": "Créez des formations, podcasts et parcours assistés par IA.",
  "dashboard.lo.newFormation": "Nouvelle formation",
  "dashboard.lo.generateAi": "Générer avec IA",
  "dashboard.lo.aiGenerations": "Générations IA",
  "dashboard.lo.recentActivity": "Activité récente",
  "dashboard.lo.activityFormationPublished": "Formation publiée",
  "dashboard.lo.activityFormationEdited": "Formation modifiée",
  "dashboard.lo.activityPodcastPublished": "Podcast publié",
  "dashboard.lo.activityPodcastEdited": "Podcast modifié",
  "dashboard.certificatesIssued": "Certificats délivrés",
  "dashboard.searchProjects": "Rechercher des projets...",
  "dashboard.noProjects": "Aucun projet pour le moment",
  "dashboard.createFirst": "Créez votre premier projet pour commencer",
  "dashboard.createProject": "Créer un projet",
  "dashboard.projectTitle": "Titre du projet",
  "dashboard.calendar.mon": "Lun",
  "dashboard.calendar.wed": "Mer",
  "dashboard.calendar.fri": "Ven",
  "dashboard.calendar.less": "Moins",
  "dashboard.calendar.more": "Plus",
  "dashboard.calendar.tooltip": "{{count}} activite(s) le {{date}}",
  "dashboard.mock.updated2h": "Il y a 2 h",
  "dashboard.mock.updated5h": "Il y a 5 h",
  "dashboard.mock.updatedYesterday": "Hier",
  "pages.help.title": "Centre d'aide",
  "pages.help.description": "Documentation et support",
  "pages.help.hubIntro": "Thématiques couvrant l’usage de Lyrra : vous pourrez bientôt lier chaque fiche à votre documentation, tutoriels ou tickets support.",
  "pages.help.searchPlaceholder": "Rechercher une thématique…",
  "pages.help.noResults": "Aucun résultat pour cette recherche.",
  "pages.help.configHint": "Contenu de démonstration : branchez vos URLs, articles ou base de connaissances quand vous serez prêt.",
  "pages.help.comingSoonDesc": "Accédez à la documentation, aux tutoriels et au support technique pour utiliser la plateforme.",
  "pages.help.modal.steps": "En pratique",
  "pages.help.modal.tips": "Conseils",
  "pages.help.modal.related": "Voir aussi",
  "pages.help.openArticle": "Ouvrir la fiche",
  "pages.help.onboardingFlowMissing": "Formation introuvable",
  "pages.help.onboardingFlowMissingDesc": "Lancez les seeds backend (db:seed:onboarding-eduflow, db:seed:onboarding-navigation-eduflow, db:seed:onboarding-profile-eduflow, db:seed:onboarding-roles-eduflow, db:seed:onboarding-block-types-eduflow, db:seed:onboarding-designer-overview-eduflow, db:seed:onboarding-branches-eduflow, db:seed:onboarding-validation-eduflow, db:seed:onboarding-objectives-eduflow, db:seed:onboarding-ai-designer-eduflow, db:seed:onboarding-publication-status-eduflow, db:seed:onboarding-publication-links-eduflow, db:seed:onboarding-catalog-visibility-eduflow, db:seed:onboarding-enrollments-eduflow, db:seed:onboarding-groups-cohorts-eduflow, db:seed:onboarding-progress-eduflow, db:seed:onboarding-certificates-eduflow et db:seed:onboarding-media-library-eduflow) ou renseignez VITE_ONBOARDING_DASHBOARD_FLOW_ID / VITE_ONBOARDING_NAVIGATION_FLOW_ID / VITE_ONBOARDING_PROFILE_FLOW_ID / VITE_ONBOARDING_ROLES_FLOW_ID / VITE_ONBOARDING_BLOCK_TYPES_FLOW_ID / VITE_ONBOARDING_DESIGNER_OVERVIEW_FLOW_ID / VITE_ONBOARDING_BRANCHES_FLOW_ID / VITE_ONBOARDING_VALIDATION_FLOW_ID / VITE_ONBOARDING_OBJECTIVES_FLOW_ID / VITE_ONBOARDING_AI_DESIGNER_FLOW_ID / VITE_ONBOARDING_PUBLICATION_STATUS_FLOW_ID / VITE_ONBOARDING_PUBLICATION_LINKS_FLOW_ID / VITE_ONBOARDING_CATALOG_VISIBILITY_FLOW_ID / VITE_ONBOARDING_ENROLLMENTS_FLOW_ID / VITE_ONBOARDING_GROUPS_COHORTS_FLOW_ID / VITE_ONBOARDING_PROGRESS_FLOW_ID / VITE_ONBOARDING_CERTIFICATES_FLOW_ID / VITE_ONBOARDING_MEDIA_LIBRARY_FLOW_ID.",
  "pages.help.onboardingDashboardPlayerTitle": "Formation — Tableau de bord Lyrra (onboarding)",
  "pages.help.onboardingNavigationPlayerTitle": "Formation — Navigation & menu latéral Lyrra (onboarding)",
  "pages.help.onboardingProfilePlayerTitle": "Formation — Profil & préférences Lyrra (onboarding)",
  "pages.help.onboardingRolesPlayerTitle": "Formation — Rôles et droits d'accès Lyrra (onboarding)",
  "pages.help.onboardingBlockTypesPlayerTitle": "Formation — Types de blocs EduFlow (onboarding)",
  "pages.help.onboardingDesignerOverviewPlayerTitle": "Formation — Vue d’ensemble du concepteur EduFlow (onboarding)",
  "pages.help.onboardingBranchesPlayerTitle": "Formation — Branches & conditions EduFlow (onboarding)",
  "pages.help.onboardingValidationPlayerTitle": "Formation — Validation du parcours EduFlow (onboarding)",
  "pages.help.onboardingObjectivesPlayerTitle": "Formation — Objectifs pédagogiques EduFlow (onboarding)",
  "pages.help.onboardingAiDesignerPlayerTitle": "Formation — Assistant IA du designer LyrraOne (onboarding)",
  "pages.help.onboardingPublicationStatusPlayerTitle": "Formation — Brouillon, publication et mises à jour LyrraOne (onboarding)",
  "pages.help.onboardingPublicationLinksPlayerTitle": "Formation — Liens d’accès & partage LyrraOne (onboarding)",
  "pages.help.onboardingCatalogVisibilityPlayerTitle": "Formation — Catalogue & visibilité LyrraOne (onboarding)",
  "pages.help.onboardingEnrollmentsPlayerTitle": "Formation — Inscriptions & participants LyrraOne (onboarding)",
  "pages.help.onboardingGroupsCohortsPlayerTitle": "Formation — Groupes & cohortes LyrraOne (onboarding)",
  "pages.help.onboardingProgressPlayerTitle": "Formation — Progression & temps passé LyrraOne (onboarding)",
  "pages.help.onboardingCertificatesPlayerTitle": "Formation — Certificats délivrés LyrraOne (onboarding)",
  "pages.help.onboardingMediaLibraryPlayerTitle": "Formation — Bibliothèque média LyrraOne (onboarding)",
  "dashboard.vsLastPeriod": "par rapport à la période précédente ({{period}})",
  "dashboard.activeLearners": "Apprenants actifs",
  "dashboard.sessions": "Sessions",
  "dashboard.activityType.completion": "Terminé",
  "dashboard.activityType.enrollment": "Inscription",
  "dashboard.activityType.milestone": "Étape",
  "dashboard.activityType.feedback": "Feedback",
  "dashboard.activityType.start": "Démarrage",
  "dashboard.activeEduFlows": "Formations actives",
  "dashboard.completionRate": "Taux de complétion",
  "dashboard.npsScore": "Score NPS",
  "dashboard.topEduFlowsHint": "Taux de complétion des formations les plus suivies (tri par nombre d’inscrits).",
  "dashboard.engagement": "Engagement des apprenants",
  "podcast.episodes.filterAllPodcasts": "Tous les podcasts",
  "podcast.episodes.unassignedPodcast": "Sans podcast",
  "podcast.episodes.generateVoiceOff": "Générer la voix off",
  "podcast.episodes.generateVoiceConfirmTitle": "Générer la voix off ?",
  "podcast.episodes.generateVoiceConfirmMessage": "L’épisode « {{title}} » sera synthétisé ({{count}} segment(s)). Cela peut prendre plusieurs minutes.",
  "podcast.episodes.generateVoiceConfirmButton": "Générer",
  "podcast.episodes.generateNoBlocks": "Aucun texte ni enregistrement micro sur cet épisode — ouvrez l’éditeur pour ajouter du contenu.",
  "podcast.episodes.generateSuccess": "Voix off générée pour « {{title}} » ({{count}} segment(s)).",
  "podcast.episodes.generateError": "Échec de la génération de la voix off.",
  "podcast.episodes.publish": "Publier l’épisode",
  "podcast.episodes.publishConfirmTitle": "Publier cet épisode ?",
  "podcast.episodes.publishConfirmMessage": "« {{title}} » sera visible pour les apprenants assignés au podcast (statut publié).",
  "podcast.episodes.publishConfirmButton": "Publier",
  "podcast.episodes.publishSuccess": "« {{title}} » est publié.",
  "podcast.episodes.publishError": "Échec de la publication.",
  "podcast.episodes.audioReady": "Audio prêt",
  "podcast.createEpisode.coverTooLarge": "L’image ne doit pas dépasser 5 Mo.",
  "eduflow.list.archiveFormation": "Archiver la formation",
  "eduflow.list.restoreFromArchive": "Restaurer depuis les archives (brouillon)",
  "eduflow.list.archiveSuccess": "Formation archivée",
  "eduflow.list.archiveError": "Impossible d’archiver la formation.",
  "eduflow.list.restoreSuccess": "Formation restaurée en brouillon",
  "eduflow.list.restoreError": "Impossible de restaurer la formation.",
  "eduflow.shareFormation.inviteEmailsTitle": "Inviter par e-mail (compte existant)",
  "eduflow.shareFormation.inviteEmailsHint": "Une ou plusieurs adresses : comptes LyrraOne uniquement (y compris d’une autre institution). Les personnes sans compte ne sont pas ajoutées — utilisez « Créer un nouvel apprenant » pour les inviter.",
  "eduflow.shareFormation.inviteEmailsPlaceholder": "Une adresse par ligne ou séparées par des virgules\nexemple@lyrra.fr, autre@entreprise.com",
  "eduflow.shareFormation.inviteEmailsSubmit": "Ajouter ces comptes à la formation",
  "eduflow.shareFormation.inviteEmailsInvalid": "Saisissez au moins une adresse e-mail valide.",
  "eduflow.shareFormation.inviteEmailsError": "Impossible d’ajouter les adresses.",
  "eduflow.shareFormation.inviteEmailsSummaryOk": "{{count}} compte(s) ajouté(s).",
  "eduflow.shareFormation.inviteEmailsSummaryNoAccount": "{{count}} sans compte LyrraOne.",
  "eduflow.shareFormation.inviteEmailsSummaryAlready": "{{count}} déjà assigné(s).",
  "eduflow.versionHistory.create": "Créer une version",
  "eduflow.versionHistory.createVersion": "Créer v{{version}}",
  "eduflow.versionHistory.minor": "Mineure",
  "eduflow.versionHistory.major": "Majeure",
  "eduflow.versionHistory.minorBadge": "Version mineure",
  "eduflow.versionHistory.majorBadge": "Version majeure",
  "eduflow.versionHistory.publish": "Publier cette version",
  "eduflow.versionHistory.publishCta": "Publier",
  "eduflow.versionHistory.systemPublished": "Publication de {{version}}",
  "eduflow.versionHistory.systemSaved": "Sauvegarde {{version}}",
  "eduflow.versionHistory.systemAutosaveRestore": "Sauvegarde automatique avant restauration de {{version}}",
  "eduflow.versionHistory.descriptionPlaceholder": "Description des changements…",
  "eduflow.versionHistory.restoreTitle": "Restaurer la version v{{version}} ?",
  "eduflow.versionHistory.restoreWarning": "Le contenu actuel sera remplacé. Une sauvegarde automatique sera créée avant la restauration.",
  "eduflow.versionHistory.createSuccess": "Version {{version}} créée",
  "eduflow.versionHistory.restoreSuccess": "Version {{version}} restaurée",
  "eduflow.versionHistory.restoreError": "Erreur lors de la restauration",
  "eduflow.versionHistory.publishSuccess": "Version {{version}} publiée",
  "eduflow.versionHistory.publishError": "Erreur lors de la publication",
  "eduflow.versionHistory.now": "à l'instant",
  "eduflow.designer.paletteCategory.structure": "Parcours & structure",
  "eduflow.designer.paletteCategory.content": "Contenu & médias",
  "eduflow.designer.paletteCategory.interactive": "Activités & évaluation",
  "eduflow.designer.paletteCategory.accessibility": "Accessibilité (DYS)",
  "eduflow.designer.paletteCategory.enterprise": "Conformité & avancé",
  "eduflow.designer.flowSettings.toolbarTitle": "Paramètres formation & lecteur",
  "eduflow.designer.flowSettings.panelTitle": "Paramètres de la formation",
  "eduflow.designer.flowSettings.intro": "Ces informations sont affichées côté lecteur (titre, description, visuel). Le bouton « Précédent » peut être masqué pour un parcours strictement linéaire.",
  "eduflow.designer.flowSettings.titleLabel": "Titre de la formation",
  "eduflow.designer.flowSettings.descriptionLabel": "Description de la formation",
  "eduflow.designer.flowSettings.coverLabel": "Image de couverture",
  "eduflow.designer.flowSettings.coverUpload": "Importer une image",
  "eduflow.designer.flowSettings.coverUrlPlaceholder": "Ou coller une URL d’image (https://…)",
  "eduflow.designer.flowSettings.coverRemove": "Retirer la couverture",
  "eduflow.designer.flowSettings.allowPreviousLabel": "Bouton « Précédent » dans le lecteur",
  "eduflow.designer.flowSettings.allowPreviousHint": "Désactivé : l’apprenant ne peut pas revenir au bloc précédent (ni par raccourci clavier).",
  "eduflow.designer.flowSettings.focusGuard.title": "Vérification de perte de focus",
  "eduflow.designer.flowSettings.focusGuard.hint": "Si l’apprenant quitte l’onglet ou la page, la formation se met en pause (écran grisé, reprise au clic).",
  "eduflow.designer.flowSettings.focusGuard.limitLabel": "Sorties autorisées",
  "eduflow.designer.flowSettings.focusGuard.unlimited": "Illimité",
  "eduflow.designer.flowSettings.focusGuard.limited": "Limité",
  "eduflow.designer.flowSettings.focusGuard.lossesUnit": "perte(s) de focus autorisée(s)",
  "eduflow.designer.flowSettings.focusGuard.blockWarning": "Au-delà de ce nombre, l’apprenant ne peut plus continuer la formation.",
  "eduflow.designer.flowSettings.coverUploadError": "Impossible d'envoyer la couverture.",
  "eduflow.designer.flowSettings.certificate.uploadError": "Réponse serveur invalide.",
  "eduflow.designer.flowSettings.certificate.uploadFailed": "Impossible d'envoyer le modèle Word.",
  "eduflow.designer.blockLabel.start": "Départ",
  "eduflow.designer.blockLabel.end": "Fin",
  "eduflow.summary.editorHint": "Liste les notions ou étapes vues dans la formation. Chaque ligne apparaît comme une carte numérotée dans le lecteur.",
  "eduflow.designer.blockLabel.form": "Formulaire",
  "eduflow.designer.blockLabel.loop": "Boucle",
  "eduflow.designer.blockLabel.merge": "Convergence",
  "eduflow.designer.blockLabel.split": "Embranchement",
  "eduflow.designer.blockLabel.subflow": "Sous-formation",
  "eduflow.designer.blockLabel.timer": "Minuteur",
  "eduflow.designer.blockLabel.email": "Email automatique",
  "eduflow.designer.blockLabel.text": "Texte",
  "eduflow.designer.blockLabel.podcast": "PodCast",
  "eduflow.designer.blockLabel.video": "Vidéo",
  "eduflow.designer.blockLabel.audio": "Audio",
  "eduflow.designer.blockLabel.image": "Image annotée",
  "eduflow.designer.blockLabel.pdf": "Document PDF",
  "eduflow.designer.blockLabel.browser": "Page web intégrée",
  "eduflow.designer.blockLabel.presentation": "Diaporama",
  "eduflow.designer.blockLabel.timeline": "Frise chronologique",
  "eduflow.designer.blockLabel.chart": "Graphique interactif",
  "eduflow.designer.blockLabel.mindmap": "Carte mentale",
  "eduflow.designer.blockLabel.visual_ai": "Visuel IA",
  "eduflow.designer.blockLabel.quiz_mcq": "Quiz (QCM / V-F / Ordre)",
  "eduflow.designer.blockLabel.poll": "Sondage en direct",
  "eduflow.designer.blockLabel.self_assessment": "Auto-évaluation",
  "eduflow.selfAssessment.panelHint": "Définissez chaque dimension à noter : intitulé court et, si besoin, une description pour guider l’apprenant.",
  "eduflow.selfAssessment.emptyCriteria": "Aucun critère. Ajoutez au moins une ligne pour que l’apprenant puisse s’auto-évaluer.",
  "eduflow.selfAssessment.criterionTitlePh": "Ex. Communication, Autonomie…",
  "eduflow.selfAssessment.criterionDescriptionPh": "Précisez ce que l’apprenant doit observer ou comment se positionner…",
  "eduflow.selfAssessment.badgeOptionsHint": "Mots ou courtes expressions : l’apprenant les choisit comme pastilles. Sans proposition → champ texte libre.",
  "eduflow.selfAssessment.textModeHint": "L’apprenant rédige une réponse pour chaque critère. Le commentaire global reste disponible sous les critères dans le lecteur.",
  "eduflow.designer.blockLabel.evaluation": "Évaluation multi-questions",
  "eduflow.designer.blockLabel.phrase_reveal": "Révélation progressive",
  "eduflow.designer.blockLabel.voice_assessment": "Évaluation vocale",
  "eduflow.designer.blockLabel.dys_reader": "Lecteur DYS (syllabes + TTS)",
  "eduflow.designer.blockLabel.dys_image_zones": "Image zones interactives",
  "eduflow.designer.blockLabel.dys_clock": "Horloge colorée DYS",
  "eduflow.designer.blockLabel.dys_reading_practice": "Exercice lecture adaptée",
  "eduflow.designer.blockLabel.glossary": "Glossaire + Quiz intégré",
  "eduflow.designer.blockLabel.html": "HTML / JavaScript personnalisé",
  "eduflow.designer.blockLabel.certification": "Certificat (template Word)",
  "eduflow.designer.blockLabel.signature": "Signature apprenant",
  "eduflow.designer.blockLabel.facial_recognition": "Reconnaissance faciale",
  "eduflow.designer.blockLabel.attendance": "Émargement numérique",
  "eduflow.designer.startBlockTitle": "Départ",
  "eduflow.designer.placeholderUntitled": "Sans titre",
  "eduflow.designer.placeholderFlowDescription": "Description de la formation (255 caractères max)",
  "eduflow.designer.saving": "Enregistrement…",
  "eduflow.designer.unsaved": "Non enregistré",
  "eduflow.designer.saved": "Enregistré",
  "eduflow.designer.blocksPanelTitle": "Blocs",
  "eduflow.designer.paletteSearchLabel": "Rechercher un bloc",
  "eduflow.designer.paletteSearchPlaceholder": "Rechercher un bloc…",
  "eduflow.designer.paletteSearchEmpty": "Aucun bloc ne correspond à votre recherche.",
  "eduflow.designer.autoLayoutShort": "Auto-layout",
  "eduflow.designer.validate": "Valider",
  "eduflow.designer.validateTitle": "Valider le parcours",
  "eduflow.designer.validationBeforePreview": "Corrigez les erreurs du parcours avant l’aperçu.",
  "eduflow.designer.validationBeforePublish": "Corrigez les erreurs du parcours avant de publier.",
  "eduflow.designer.aiShort": "IA",
  "eduflow.designer.aiTitle": "Assistant IA",
  "eduflow.designer.ragChatbotTitle": "Chatbot formation",
  "eduflow.ragChatbot.needDoc": "Ajoutez au moins un document avant d’activer le chatbot.",
  "eduflow.ragChatbot.uploadSavedNotIndexed": "Document enregistré. Il ne sera pas utilisé par le RAG tant que la base vectorielle n’est pas configurée sur le serveur.",
  "eduflow.ragChatbot.ragIndexFailed": "Document enregistré, mais non indexé. Vérifiez pgvector (DATABASE_VECTOR_URL) et Mistral, puis réimportez si besoin.",
  "eduflow.ragChatbot.vectorHint": "Pour indexer des PDF / TXT / MD : configurez DATABASE_VECTOR_URL ou PGVECTOR_HOST (PostgreSQL + extension pgvector) et Mistral dans Administration → Intégrations plateforme (clé + modèle d’embeddings). Sans cela, l’upload et l’indexation échouent.",
  "eduflow.ragChatbot.chatHint": "Les réponses et les embeddings RAG utilisent Mistral. Les documents ajoutés ici sont cherchés via embeddings Mistral + pgvector ; sans document, seul le texte des blocs du parcours sert de contexte.",
  "eduflow.ragChatbot.playerToggleHint": "Les apprenants posent des questions uniquement sur le contenu de cette formation : texte des blocs du parcours, et extraits des documents indexés si vous en avez ajouté.",
  "eduflow.ragChatbot.docCount": "Documents indexés : {{count}}",
  "eduflow.ragChatbot.playerDisclaimer": "Réponses basées sur les documents et le contenu de cette formation uniquement.",
  "eduflow.designer.aiPanel.welcome": "Décrivez ce que vous voulez faire. Le bloc ouvert dans **Propriétés** est la cible par défaut. Utilisez la **viseur** pour capturer l’écran (canevas + formulaire) : l’IA analyse et remplit les champs via le canevas.",
  "eduflow.designer.aiPanel.askBeforeAct": "Demander avant d’agir",
  "eduflow.designer.aiPanel.askBeforeActHint": "Si activé, les modifications sont proposées dans le chat avant application sur le graphe.",
  "eduflow.designer.aiPanel.captureScreenHint": "Capturer le canevas et le panneau Propriétés (analyse visuelle)",
  "eduflow.designer.aiPanel.captureReady": "Capture prête — envoyez votre consigne.",
  "eduflow.designer.aiPanel.captureFailed": "Impossible de capturer l’écran.",
  "eduflow.designer.aiPanel.captureAttached": "Capture d’écran jointe au prochain envoi",
  "eduflow.designer.aiPanel.removeCapture": "Retirer",
  "eduflow.designer.aiPanel.captureInMessage": "Capture écran",
  "eduflow.designer.aiPanel.statusCapturing": "Capture de l’interface…",
  "eduflow.designer.aiPanel.statusAnalyzing": "Analyse de l’écran et du bloc ouvert…",
  "eduflow.designer.aiPanel.statusWorking": "Traitement de votre demande…",
  "eduflow.designer.aiPanel.statusApplying": "Application sur le canevas…",
  "eduflow.designer.aiPanel.captureDisclaimer": "L’IA peut se tromper : vérifiez le contenu généré. Collez une image (Ctrl+V) ou utilisez la capture.",
  "eduflow.designer.resizeAiPanel": "Redimensionner le panneau assistant IA",
  "eduflow.designer.aiPanel.subtitle": "Copilote : contenu, graphe et objectifs.",
  "eduflow.designer.aiPanel.focusContextLabel": "Cible :",
  "eduflow.designer.aiPanel.focusPrimary": "« {{label}} » ({{type}}) — Propriétés",
  "eduflow.designer.aiPanel.focusMulti": "{{count}} blocs sélectionnés — précisez lequel modifier ou un seul bloc au focus.",
  "eduflow.designer.aiPanel.focusNone": "Aucun bloc ciblé — ouvrez Propriétés sur un nœud ou nommez un bloc dans le message.",
  "eduflow.designer.aiPanel.followUpsLabel": "Suite suggérée",
  "eduflow.designer.aiPanel.ideasToggle": "Idées prêtes à l’emploi",
  "eduflow.designer.aiPanel.advancedToggle": "Options (streaming, sources, raccourcis…)",
  "eduflow.designer.aiPanel.removeDocument": "Retirer",
  "eduflow.designer.aiPanel.importDocumentTitle": "Importer PDF, Word ou PowerPoint",
  "eduflow.designer.aiPanel.webSourcesLabel": "Pages web (max 3, optionnel)",
  "eduflow.designer.aiPanel.webSourcesPlaceholder": "https://exemple.fr/doc\nhttps://…",
  "eduflow.designer.aiPanel.idea.auditPath": "Audite tout le graphe : impasses, nœuds isolés et ordre du parcours — propose les corrections nécessaires",
  "eduflow.designer.aiPanel.idea.microLearning": "À partir du parcours actuel, propose une variante courte type micro-learning tout en gardant les idées",
  "eduflow.designer.aiPanel.idea.formativeGap": "Insère une médiation formative (activité courte) aux endroits les plus denses cognitivement",
  "eduflow.designer.aiPanel.idea.titleCoherence": "Aligne les titres des blocs sur le titre du projet et le ton général décrit dans la formation",
  "eduflow.designer.aiPanel.idea.remediation": "Ajoute un chemin de remédiation après le principal QCM (branche échec / score bas)",
  "eduflow.designer.aiPanel.idea.mobileWording": "Raccourcis et clarifie les textes HTML des blocs trop longs pour lecture mobile",
  "eduflow.designer.aiPanel.idea.quizWording": "Unifie le style des consignes (« Choisis », « Sélectionnez », niveau formel…) sur tous les quiz",
  "eduflow.designer.aiPanel.idea.summaryBeforeEnd": "Insère ou rédige un bloc de synthèse juste avant le bloc Fin",
  "eduflow.designer.aiPanel.streamMode": "Streaming",
  "eduflow.designer.aiPanel.streamModeHint": "Réponse affichée au fil de l’eau ; le résultat final est traité comme sans streaming.",
  "eduflow.designer.aiPanel.streamError": "Flux IA interrompu ou refusé.",
  "eduflow.designer.aiPanel.streamIncomplete": "Réponse incomplète depuis le serveur. Réessayez ou désactivez le streaming.",
  "eduflow.designer.aiPanel.skillPath": "Audit du parcours (serveur)",
  "eduflow.designer.aiPanel.skillPathHint": "Analyse structurelle du graphe ajoutée au prompt.",
  "eduflow.designer.aiPanel.skillQuiz": "Schéma QCM strict (serveur)",
  "eduflow.designer.aiPanel.skillQuizHint": "Gabarit officiel quiz_mcq dans le prompt.",
  "eduflow.designer.aiPanel.thinking": "L'assistant réfléchit…",
  "eduflow.designer.aiPanel.serverSkills": "Renforts côté serveur",
  "eduflow.designer.aiPanel.quickActions": "Actions rapides",
  "eduflow.designer.aiPanel.placeholder": "Question, idée, relecture, structure du parcours, contenu d’un bloc…",
  "eduflow.designer.aiPanel.apply": "Appliquer au canevas",
  "eduflow.designer.aiPanel.autoApply": "Appliquer tout seul au graphe",
  "eduflow.designer.aiPanel.autoApplyHint": "Les opérations structurées de l’assistant modifient le parcours sans clic sur « Appliquer ».",
  "eduflow.designer.aiPanel.dismissOps": "Ignorer",
  "eduflow.designer.aiPanel.applied": "Modifications appliquées au parcours.",
  "eduflow.designer.aiPanel.applyPartial": "Appliqué avec avertissements : {{details}}",
  "eduflow.designer.aiPanel.applyFailed": "Aucune opération n’a pu être appliquée sur le canevas (format des opérations ou types de blocs invalides).",
  "eduflow.designer.aiPanel.objectivesSaved": "Objectifs pédagogiques enregistrés (panneau Objectifs).",
  "eduflow.designer.aiPanel.objectivesSaveError": "Impossible d’enregistrer les objectifs. Réessayez.",
  "eduflow.designer.aiPanel.error": "Impossible de contacter l’assistant. Vérifiez la configuration IA (clé API) et le réseau.",
  "eduflow.designer.aiPanel.newConversation": "Nouvelle conversation",
  "eduflow.designer.aiPanel.clearConversation": "Vider la conversation",
  "eduflow.designer.aiPanel.conversationHistory": "Historique",
  "eduflow.designer.aiPanel.deleteConversation": "Supprimer",
  "eduflow.designer.aiPanel.maxConversations": "Vous avez atteint la limite de {{max}} conversations enregistrées. Supprimez-en une pour en créer une nouvelle.",
  "eduflow.designer.aiPanel.unnamedConversation": "Conversation",
  "eduflow.designer.aiQuick.plan": "Plan de parcours",
  "eduflow.designer.aiQuick.expand": "Blocs interactifs",
  "eduflow.designer.aiQuick.quiz": "Module QCM",
  "eduflow.designer.aiQuick.objectives": "Objectifs (panneau)",
  "eduflow.designer.aiQuick.rewriteFocus": "Réécrire le bloc Propriétés",
  "eduflow.designer.aiQuick.translateFocus": "Traduire le bloc Propriétés (EN)",
  "eduflow.designer.voiceShort": "Voix",
  "eduflow.designer.voiceTitle": "Configuration vocale",
  "eduflow.designer.objectivesShort": "Objectifs",
  "eduflow.designer.objectivesTitle": "Objectifs pédagogiques",
  "eduflow.designer.flowVariablesTitle": "Variables globales",
  "eduflow.designer.flowVariables.subtitle": "Définissez des paires clé / valeur. Utilisez @suivi du nom de la clé dans les titres et descriptions des blocs (ex. @nom_formation). Les valeurs sont substituées pour les apprenants.",
  "eduflow.designer.flowVariables.empty": "Aucune variable. Ajoutez-en pour personnaliser les textes du parcours.",
  "eduflow.designer.flowVariables.keyLabel": "Clé",
  "eduflow.designer.flowVariables.keyPlaceholder": "ex. nom_formation",
  "eduflow.designer.flowVariables.keyHelp": "Lettres, chiffres, tiret et underscore uniquement. Sensible à la casse pour @cle.",
  "eduflow.designer.flowVariables.valueLabel": "Valeur par défaut",
  "eduflow.designer.flowVariables.valuePlaceholder": "Texte affiché à la place de @cle",
  "eduflow.designer.flowVariables.add": "Ajouter une variable",
  "eduflow.designer.flowVariables.delete": "Supprimer",
  "eduflow.designer.flowVariables.invalidKey": "Chaque clé doit être renseignée et ne contenir que des caractères autorisés.",
  "eduflow.designer.flowVariables.duplicateKey": "Deux clés identiques (sans tenir compte de la casse) ne sont pas autorisées.",
  "eduflow.designer.flowVariables.savedToast": "Variables enregistrées",
  "eduflow.designer.flowVariables.errorToast": "Impossible d’enregistrer les variables.",
  "eduflow.designer.flowVariables.saveNow": "Enregistrer",
  "eduflow.designer.blockFlowVariablesHint": "Variables globales : utilisez @votre_cle dans le titre ou la description (configurez-les via l’icône { } dans la barre d’outils).",
  "eduflow.designer.blockFlowVariablesPreviewTitle": "Aperçu (titres)",
  "eduflow.designer.blockFlowVariablesPreviewDescription": "Aperçu (description)",
  "eduflow.designer.flowVariables.mentionNoMatch": "Aucune variable ne correspond.",
  "eduflow.designer.formFieldsSlash.mentionNoMatch": "Aucun champ ne correspond.",
  "eduflow.designer.onlineCount": "{{count}} en ligne",
  "eduflow.designer.editingBlocks_one": "{{count}} bloc en édition",
  "eduflow.designer.editingBlocks_other": "{{count}} blocs en édition",
  "eduflow.designer.invite": "Inviter",
  "eduflow.designer.inviteTitle": "Inviter un collaborateur",
  "eduflow.designer.exportTitle": "Exporter le parcours",
  "eduflow.designer.importTitle": "Importer un parcours (fichier ou collage JSON)",
  "eduflow.designer.exportNeedSavedFlow": "Enregistrez la formation avant d’exporter un fichier .lyrra.",
  "eduflow.designer.canvasUntitled": "Sans titre",
  "eduflow.designer.selectBlock": "Sélectionnez un bloc",
  "eduflow.designer.selectBlockHint": "Cliquez sur un bloc du canvas pour modifier ses propriétés",
  "eduflow.designer.blockPropertiesSubtitle": "Propriétés du bloc",
  "eduflow.designer.textVoiceoverHint": "La voix off lit la description et le contenu du bloc.",
  "eduflow.designer.blockLockedReadOnly": "Ce bloc est verrouillé : les propriétés sont affichées en lecture seule.",
  "eduflow.designer.blockTitleField": "Titre",
  "eduflow.designer.blockTitlePlaceholder": "Titre du bloc",
  "eduflow.designer.you": "Vous",
  "eduflow.designer.blockInfoPosition": "ID: {{id}} | Position: ({{x}}, {{y}})",
  "eduflow.designer.toastBlockCopied": "Bloc copié",
  "eduflow.designer.toastCollaboratorInvited": "Collaborateur invité",
  "eduflow.designer.toastInviteError": "Impossible d’inviter ce collaborateur",
  "eduflow.designer.createFlowError": "Impossible de créer le parcours",
  "eduflow.designer.loadFlowError": "Impossible de charger cette formation.",
  "eduflow.designer.loadFlowForbidden": "Vous n’avez pas accès à cette formation.",
  "eduflow.designer.loadFlowNotFound": "Formation introuvable ou supprimée.",
  "eduflow.designer.editConnection": "Modifier la connexion",
  "eduflow.designer.deleteConnection": "Supprimer la connexion",
  "eduflow.translation.toolbarTitle": "Traduction du contenu",
  "eduflow.translation.toolbarShort": "Traduction",
  "eduflow.translation.title": "Traduction multilingue",
  "eduflow.translation.subtitle": "Traduisez les textes des blocs (IA) et régénérez la voix off des descriptions si besoin. Les résultats sont enregistrés par langue.",
  "eduflow.translation.subtitleV2": "Choisissez une voix Mistral par langue : elles servent aux voix off générées dans le player (traduction à la demande). Les jobs de traduction ci-dessous restent optionnels.",
  "eduflow.translation.voicesSection": "Voix TTS par langue",
  "eduflow.translation.voicesSectionHint": "Aperçu dans la langue concernée. Sans voix choisie : « Marie - sad » pour le français, l’italien et l’espagnol ; « Paul - sad » pour les autres langues.",
  "eduflow.translation.voicesLangCount": "{{count}} langues (FR, EN, ES, DE, IT, PT, LB, UK, RU, AR) : choisissez une voix dans la liste, puis « Écouter » pour un court extrait.",
  "eduflow.translation.voicesLoadError": "Impossible de charger les voix. Vérifiez votre connexion ou réessayez.",
  "eduflow.translation.voicePreview": "Écouter",
  "eduflow.translation.previewStop": "Stop",
  "eduflow.translation.voicePlaceholder": "— Choisir une voix —",
  "eduflow.translation.voiceSelectAria": "Voix pour {{lang}}",
  "eduflow.translation.voicesSaveError": "Impossible de sauvegarder les voix.",
  "eduflow.translation.selectVoiceFirst": "Choisissez une voix pour cette langue.",
  "eduflow.translation.previewError": "Échec de la lecture audio.",
  "eduflow.translation.batchSection": "Traductions précalculées (optionnel)",
  "eduflow.translation.batchSectionHint": "Le player peut traduire à la volée ; lancez un job seulement si vous voulez figer texte + audio en base à l’avance.",
  "eduflow.translation.sourceLang": "Langue source du parcours",
  "eduflow.translation.bulkSection": "Toutes les langues",
  "eduflow.translation.includeText": "Texte",
  "eduflow.translation.includeAudio": "Audio (voix off description)",
  "eduflow.translation.runAll": "Traduire toutes les langues (sauf la source)",
  "eduflow.translation.runAllHint": "Lance un job par langue cible parmi les 12 langues supportées, en excluant la langue source.",
  "eduflow.translation.perLanguage": "Par langue",
  "eduflow.translation.sourceBadge": "Source",
  "eduflow.translation.runOne": "Traduire",
  "eduflow.translation.history": "Jobs récents",
  "eduflow.translation.noHistory": "Aucun job pour l’instant.",
  "eduflow.translation.saveFirst": "Enregistrez le parcours avant de lancer une traduction.",
  "eduflow.translation.prefsSaveError": "Impossible d’enregistrer les préférences de traduction (cases Texte / Audio par langue).",
  "eduflow.translation.jobStarted": "Traduction lancée vers {{lang}}.",
  "eduflow.translation.jobError": "Impossible de lancer la traduction.",
  "eduflow.translation.bulkStarted": "{{count}} traduction(s) lancée(s).",
  "eduflow.translation.bulkNone": "Aucun nouveau job : des traductions sont déjà en cours pour toutes les langues cibles, ou les options sont vides.",
  "eduflow.translation.bulkError": "Impossible de lancer les traductions groupées.",
  "eduflow.translation.statusPending": "En attente",
  "eduflow.translation.statusProcessing": "En cours",
  "eduflow.translation.statusCompleted": "Terminé",
  "eduflow.translation.statusFailed": "Échec",
  "eduflow.translation.missingSourceAudioHint": "Traduction avec audio : générez d’abord la voix off (langue {{lang}}) pour chaque description longue. Bloc(s) concerné(s) ({{count}}) : {{blocks}}.",
  "eduflow.translation.missingSourceAudioToast": "{{count}} bloc(s) sans voix off dans la langue du parcours : {{blocks}}. Générez l’audio depuis les propriétés du bloc, puis relancez.",
  "project.title": "Projets",
  "project.new": "Nouveau projet",
  "project.name": "Nom du projet",
  "project.description": "Description du projet",
  "project.status.draft": "Brouillon",
  "project.status.published": "Publié",
  "project.status.archived": "Archivé",
  "project.status.in_review": "En révision",
  "project.visibility.public": "Public",
  "project.visibility.private": "Privé",
  "project.visibility.institution": "Établissement",
  "project.no_projects": "Aucun projet trouvé",
  "project.delete_confirm": "Êtes-vous sûr de vouloir supprimer ce projet ?",
  "store.categories": "Catégories",
  "store.price": "Prix",
  "store.free": "Gratuit",
  "store.buy": "Acheter",
  "store.add_to_cart": "Ajouter au panier",
  "store.cart": "Panier",
  "store.checkout": "Commander",
  "store.reviews": "Avis",
  "store.rating": "Note",
  "store.my_purchases": "Mes achats",
  "store.no_items": "Aucun article trouvé",
  "audio.title": "Studio Audio",
  "audio.audiobooks": "Livres audio",
  "audio.new_audiobook": "Nouveau livre audio",
  "audio.record": "Enregistrer",
  "audio.stop": "Arrêter",
  "audio.play": "Lecture",
  "audio.pause": "Pause",
  "audio.volume": "Volume",
  "audio.tracks": "Pistes",
  "audio.add_track": "Ajouter une piste",
  "audio.remove_track": "Supprimer la piste",
  "audio.effects": "Effets",
  "audio.export": "Exporter",
  "audio.export_format": "Format d'export",
  "audio.duration": "Durée",
  "audio.narrator": "Narrateur",
  "audio.chapter": "Chapitre",
  "notification.title": "Notifications",
  "notification.mark_all_read": "Tout marquer comme lu",
  "notification.no_notifications": "Aucune notification",
  "notification.new": "Nouvelle notification",
  "notification.type.info": "Information",
  "notification.type.success": "Succès",
  "notification.type.warning": "Avertissement",
  "notification.type.error": "Erreur",
  "settings.title": "Paramètres",
  "settings.general": "Général",
  "settings.account": "Compte",
  "settings.security": "Sécurité",
  "settings.appearance": "Apparence",
  "settings.notifications": "Notifications",
  "settings.language": "Langue",
  "settings.theme": "Thème",
  "settings.theme.light": "Clair",
  "settings.theme.dark": "Sombre",
  "settings.theme.system": "Système",
  "settings.accessibility": "Accessibilité",
  "settings.font_size": "Taille de police",
  "settings.high_contrast": "Contraste élevé",
  "settings.reduced_motion": "Mouvements réduits",
  "settings.dyslexia_mode": "Mode dyslexie",
  "analytics.title": "Analytiques",
  "analytics.overview": "Vue d'ensemble",
  "analytics.learner_progress": "Progression des apprenants",
  "analytics.engagement": "Engagement",
  "analytics.completion": "Complétion",
  "analytics.time_spent": "Temps passé",
  "analytics.average_score": "Score moyen",
  "analytics.export_report": "Exporter le rapport",
  "gamification.xp": "XP",
  "gamification.streak": "Série",
  "gamification.achievements": "Réalisations",
  "gamification.daily_goal": "Objectif quotidien",
  "gamification.congratulations": "Félicitations !",
  "gamification.new_badge": "Nouveau badge débloqué !",
  "gamification.level_up": "Niveau supérieur !",
  "qualiopi.title": "Conformité Qualiopi",
  "qualiopi.dashboard": "Tableau de bord Qualiopi",
  "qualiopi.criteria": "Critère {{number}}",
  "qualiopi.indicator": "Indicateur {{number}}",
  "qualiopi.compliant": "Conforme",
  "qualiopi.non_compliant": "Non conforme",
  "qualiopi.partial": "Partiellement conforme",
  "qualiopi.not_applicable": "Non applicable",
  "qualiopi.upload_evidence": "Téléverser une preuve",
  "qualiopi.audit_date": "Date d'audit",
  "qualiopi.next_audit": "Prochain audit",
  "qualiopi.compliance_score": "Score de conformité",
  "qualiopi.action_plan": "Plan d'actions",
  "training.plan": "Plan de formation",
  "training.request": "Demande de formation",
  "training.requests": "Demandes de formation",
  "training.catalog": "Catalogue de formations",
  "training.budget": "Budget formation",
  "training.campaign": "Campagne d'entretiens",
  "training.competency": "Référentiel de compétences",
  "training.gap_analysis": "Analyse des écarts",
  "training.roi": "Retour sur investissement",
  "player.scrollDownHint": "Faites défiler pour la suite",
  "player.image.annotationNoDescription": "Aucune description pour cette annotation.",
  "player.image.noneAvailable": "Aucune image disponible",
  "player.visualAi.emptyTitle": "Aucun visuel IA configuré",
  "player.visualAi.emptyHint": "Revenez dans le concepteur pour générer ou configurer ce visuel.",
  "player.visualAi.defaultTitle": "Visuel IA",
  "player.visualAi.subtitle": "Explorez le diagramme : zoomez, faites défiler ou utilisez le mode plein écran.",
  "player.visualAi.openFullscreen": "Ouvrir en plein écran",
  "player.visualAi.closeFullscreen": "Fermer le plein écran",
  "player.visualAi.badge": "Visuel IA",
  "player.visualAi.viewportLabel": "Diagramme interactif — zoom et déplacement",
  "player.visualAi.toolbarLabel": "Contrôles du diagramme",
  "player.visualAi.zoomOut": "Zoom arrière",
  "player.visualAi.zoomIn": "Zoom avant",
  "player.visualAi.resetZoom": "Réinitialiser le zoom à 100 %",
  "player.visualAi.reset": "100 %",
  "player.visualAi.fitView": "Ajuster le diagramme à la fenêtre",
  "player.visualAi.fit": "Ajuster",
  "player.visualAi.zoomLevel": "Zoom {{percent}} %",
  "player.visualAi.viewportHint": "Molette + Ctrl (ou Cmd) pour zoomer. Flèches du clavier pour vous déplacer une fois la zone focalisée. Tab pour atteindre les contrôles.",
  "player.fullscreen": "Plein écran",
  "player.exitFullscreen": "Quitter le plein écran",
  "player.webinarFollowBanner": "Vous suivez l’animateur — la navigation est verrouillée. Vous pouvez changer la langue d’affichage via le bouton globe.",
  "player.institutionLogo": "Logo de l'organisation",
  "player.unblockRequestButton": "Demander un déblocage au formateur",
  "player.unblockRequestAgain": "Demander à nouveau",
  "player.unblockPending": "Demande envoyée — en attente de réponse de votre formateur.",
  "player.unblockRejected": "Votre demande de déblocage a été refusée.",
  "player.unblockLoginRequired": "Connectez-vous à votre compte apprenant (ou utilisez le lien personnel reçu par e-mail) pour demander un déblocage.",
  "player.unblockPublicLoginRequired": "En mode public sans inscription, la demande de déblocage n’est pas disponible. Remplissez le formulaire d’inscription de la formation ou connectez-vous à LyrraOne.",
  "player.unblockRequestSent": "Demande envoyée à votre formateur.",
  "player.unblockRequestError": "Impossible d'envoyer la demande. Réessayez.",
  "player.unblockApprovedToast": "Votre formateur a débloqué la formation. Bonne reprise !",
  "player.registrationFormHint": "Ce formulaire crée votre compte apprenant pour cette formation (e-mail, prénom et nom requis).",
  "player.registrationFormSuccess": "Inscription enregistrée. Vous pouvez poursuivre la formation.",
  "player.registrationFormError": "Impossible d'enregistrer l'inscription.",
  "notifications.unblock.title": "Demande de déblocage",
  "notifications.unblock.message": "{{name}} — {{flow}} ({{count}} sortie(s))",
  "notifications.unblock.unknownLearner": "Un apprenant",
  "notifications.unblock.unknownFlow": "Formation",
  "notifications.unblock.approve": "Débloquer",
  "notifications.unblock.reject": "Refuser",
  "notifications.unblock.approvedToast": "Formation débloquée pour cet apprenant.",
  "notifications.unblock.rejectedToast": "Demande de déblocage refusée.",
  "notifications.unblock.resolveError": "Impossible de traiter la demande. Réessayez.",
  "player.summary.blockSimplifying": "Texte simplifié en cours…",
  "player.simplifiedTextLoadingTitle": "Préparation du texte simplifié…",
  "player.simplifiedTextLoadingHint": "Nous simplifions d’abord le bloc affiché, puis le reste du parcours en arrière-plan.",
  "player.parallelBranchActionReplay": "Refaire cette voie",
  "player.parallelBranchesGridLabel": "Grille des voies parallèles",
  "player.parallelBranchesScrollHint": "Faites défiler vers la droite (ou utilisez les flèches) pour voir les autres voies.",
  "player.parallelBranchesPageNav": "Pages de voies",
  "player.parallelBranchesPageIndicator": "Page {{current}} / {{total}}",
  "player.parallelBranchesPrevPage": "Voies précédentes",
  "player.parallelBranchesNextPage": "Voies suivantes",
  "player.contentLanguageReloadFailed": "Le contenu n’a pas pu être rechargé dans cette langue (délai ou erreur serveur). La version précédente reste affichée. Réessayez dans un instant ou précalculez les traductions dans le designer.",
  "player.contentLanguageSubflowHint": "Pour mettre à jour le texte et l’audio, terminez ou quittez la sous-partie en cours, puis choisissez à nouveau la langue.",
  "player.mobileSummary": "Sommaire",
  "player.mobileObjectives": "Objectifs",
  "player.mobileMoreOptions": "Plus d'options",
  "player.podcast.showChapters": "Afficher les chapitres",
  "player.podcast.hideChapters": "Masquer les chapitres",
  "player.podcast.coverDialogLabel": "Couverture : {{title}}",
  "player.podcast.coverEnlargePodcast": "Agrandir la pochette du podcast",
  "player.podcast.coverEnlargeEpisode": "Agrandir la pochette de l'épisode",
  "player.podcast.coverEnlarge": "Agrandir la pochette",
  "player.audio.play": "Lecture",
  "player.audio.pause": "Pause",
  "player.audio.mute": "Couper le son",
  "player.audio.unmute": "Réactiver le son",
  "player.audio.seek": "Position dans la piste audio",
  "player.audio.playbackSpeed": "Vitesse de lecture",
  "player.audio.completed": "Piste audio terminée",
  "player.audio.subtitlesAria": "Texte synchronisé avec la lecture",
  "player.audio.subtitlesWaiting": "Le texte défilera ici pendant la lecture (segment selon la position).",
  "player.audio.subtitlesNeedText": "Ajoutez du texte (TTS ou contenu du bloc) pour afficher les segments ici.",
  "player.audio.subtitlesHintSr": "Synchronisation approximative : le texte est réparti sur la durée audio, sans timecodes mot à mot.",
  "player.timeline.defaultTitle": "Frise chronologique",
  "player.timeline.subtitle": "Frise chronologique à parcourir.",
  "player.timeline.eventFallback": "Événement",
  "player.timeline.voiceoverLabel": "Voix off",
  "player.timeline.playVoiceover": "Lire la voix off",
  "player.timeline.pauseVoiceover": "Pause voix off",
  "player.timeline.generateVoiceover": "Générer la voix off",
  "player.timeline.showDetail": "Voir le détail",
  "player.timeline.hideDetail": "Masquer le détail",
  "player.timeline.emptyTitle": "Aucun événement sur cette frise",
  "player.timeline.emptyHint": "Ajoutez des étapes dans le panneau de configuration du bloc.",
  "player.timeline.voiceoverUnavailableTitle": "Voix off indisponible",
  "player.timeline.voiceoverUnavailableDesc": "Ouvrez ce parcours depuis une formation connectée pour générer l’audio.",
  "player.timeline.voiceoverTextTooShortTitle": "Texte trop court",
  "player.timeline.voiceoverTextTooShortDesc": "Ajoutez une description (au moins 20 caractères) ou un titre plus détaillé pour la voix off.",
  "player.timeline.voiceoverGenerationErrorTitle": "Génération voix off impossible",
  "player.timeline.voiceoverSlowTitle": "Voix off",
  "player.timeline.voiceoverSlowDesc": "La génération prend plus de temps que prévu. Réessayez dans un instant.",
  "player.timeline.retryLater": "Réessayez plus tard.",
  "player.timeline.openFullscreen": "Ouvrir en grand",
  "player.timeline.openFullscreenAria": "Ouvrir la frise en plein écran",
  "player.timeline.closeFullscreenAria": "Fermer le plein écran",
  "player.timeline.reviewed": "Chronologie consultée",
  "player.video.seek": "Position dans la vidéo",
  "player.video.subtitlesShow": "Afficher les sous-titres",
  "player.video.subtitlesHide": "Masquer les sous-titres",
  "player.video.trackLabel": "Sous-titres",
  "player.video.completed": "Vidéo terminée",
  "player.video.markWatched": "J’ai regardé la vidéo",
  "player.video.defaultIframeTitle": "Vidéo intégrée",
  "player.podcast.playAllAria": "Tout écouter « {{title}} » — {{count}} épisode(s) avec audio",
  "player.podcast.skipNextQueuedAria": "Épisode suivant dans la file de lecture",
  "player.podcast.playEpisodeAria": "Lecture de l’épisode : {{title}}",
  "player.podcast.episodeNoAudioAria": "Épisode sans fichier audio : {{title}}",
  "player.selfAssessment.commentPlaceholder": "Réflexions personnelles, axes de progrès…",
  "player.selfAssessment.textAnswerPlaceholder": "Votre réponse…",
  "accessibility.preset.cumulHint": "Combinez plusieurs profils si besoin",
  "accessibility.preset.clickToAdd": "Cliquer pour ajouter",
  "accessibility.preset.clickToRemove": "Cliquer pour retirer",
  "accessibility.readingMask": "Masque de lecture",
  "accessibility.readingMaskDesc": "Une bande opaque suit le curseur pour isoler la ligne en cours — très utile pour la dyslexie et les TDA/H. Astuce : Option ⌥ + touche =/+ ou Option ⌥ + ↑/↓ (macOS) ; Alt + + / Alt − (Windows/Linux) pour ajuster la hauteur.",
  "accessibility.speakOnSelection": "Synthèse vocale sur sélection",
  "accessibility.speakOnSelectionDesc": "Sélectionnez du texte sur la page : un bouton apparaît pour le lire à voix haute à la demande (différent du mode lecture audio automatique).",
  "accessibility.speakSelection.listen": "Écouter la sélection",
  "accessibility.speakSelection.stop": "Arrêter la lecture",
  "accessibility.speakSelection.loading": "Génération…",
  "accessibility.speakSelection.retry": "Réessayer",
  "accessibility.speakSelection.error": "Lecture indisponible, réessayez dans quelques instants.",
  "accessibility.speakSelection.region": "Lire la sélection à voix haute",
  "a11y.voiceGuide.title": "Assistant vocal accessibilité",
  "a11y.help.shortcuts": "Raccourcis clavier",
  "a11y.help.kbdEsc": "Fermer le panneau / arrêter la synthèse vocale",
  "a11y.help.kbdMask": "Ajuster la hauteur du masque de lecture (masque activé)",
  "a11y.help.kbdMaskMac": "Touche = ou + (au-dessus des chiffres), ou flèches ↑ ↓ avec Option ⌥",
  "a11y.help.kbdMaskOther": "Windows / Linux : Alt + + / Alt + −",
  "a11y.help.kbdTab": "Naviguer entre les éléments interactifs",
  "a11y.help.tips": "Conseils",
  "a11y.voiceGuide.subtitle": "Décrivez vos besoins, j'active les bonnes options pour vous.",
  "a11y.voiceGuide.cta.title": "Décrivez vos besoins",
  "a11y.voiceGuide.cta.hint": "Parlez : l'IA active automatiquement les bonnes options pour vous.",
  "a11y.voiceGuide.cta.openLabel": "Ouvrir l'assistant vocal — décrire mes besoins d'accessibilité à voix haute",
  "a11y.voiceGuide.cta.start": "Démarrer l'assistant vocal",
  "a11y.voiceGuide.cta.stop": "Arrêter d'écouter",
  "a11y.voiceGuide.status": "Statut",
  "a11y.voiceGuide.statusActive": "En cours",
  "a11y.voiceGuide.youSaid": "Vous avez dit",
  "a11y.voiceGuide.reformulation": "Voici ce que j'ai compris",
  "a11y.voiceGuide.applied": "Réglages appliqués",
  "a11y.voiceGuide.resetButton": "Remettre en normal",
  "a11y.voiceGuide.resetExplanation": "Tous les réglages d'accessibilité ont été remis par défaut.",
  "a11y.voiceGuide.problem": "Problème",
  "a11y.voiceGuide.micReady": "Micro prêt",
  "a11y.voiceGuide.micUnsupported": "Reconnaissance vocale non supportée",
  "a11y.voiceGuide.stage.idle": "Prêt à vous écouter",
  "a11y.voiceGuide.stage.intro": "Je vous explique…",
  "a11y.voiceGuide.stage.listening": "Je vous écoute. Parlez librement.",
  "a11y.voiceGuide.stage.thinking": "Analyse de vos besoins…",
  "a11y.voiceGuide.stage.confirmPlaying": "Je résume…",
  "a11y.voiceGuide.stage.confirmListening": "Dites « oui » pour confirmer ou « non » pour recommencer.",
  "a11y.voiceGuide.stage.applying": "Application de vos réglages…",
  "a11y.voiceGuide.stage.done": "C'est fait !",
  "a11y.voiceGuide.stage.error": "Une erreur est survenue.",
  "a11y.voiceGuide.error.mic": "Impossible d'accéder au micro.",
  "a11y.voiceGuide.error.micDenied": "L'accès au microphone a été refusé. Autorisez-le dans les paramètres du navigateur.",
  "a11y.voiceGuide.error.stt": "Reconnaissance vocale non disponible sur ce navigateur.",
  "a11y.voiceGuide.error.ai": "Analyse IA indisponible.",
  "a11y.voiceGuide.error.serverUnavailable": "Le serveur Lyrra ne répond pas correctement (souvent : backend non déployé ou erreur de build). Vérifiez le déploiement, puis réessayez.",
  "a11y.voiceGuide.error.generic": "Quelque chose s'est mal passé. Réessayez ou ajustez les réglages manuellement.",
  "learner.header.workspace": "Léierberäich",
  "learner.tabs.home": "Accueil",
  "learner.tabs.parcours": "Mes Parcours",
  "learner.tabs.formations": "Mes Formations",
  "learner.tabs.webinars": "Webinaires",
  "learner.tabs.podcasts": "Podcasts",
  "learner.tabs.documents": "Documents",
  "learner.tabs.progress": "Ma Progression",
  "learner.tabs.profile": "Profil",
  "learner.sidebar.webinars": "Webinaires",
  "learner.webinars.title": "Mes webinaires",
  "learner.webinars.loading": "Chargement de vos webinaires…",
  "learner.webinars.empty": "Aucun webinaire pour le moment. Les invitations reçues et les sessions où vous êtes animateur apparaîtront ici.",
  "learner.webinars.sectionInvited": "Invitations reçues",
  "learner.webinars.sectionPresenting": "Mes sessions en tant qu’animateur",
  "learner.webinars.emptyInvited": "Aucune invitation pour le moment.",
  "learner.webinars.emptyPresenting": "Vous n’êtes animateur sur aucun webinaire.",
  "learner.webinars.rolePresenter": "Animateur",
  "learner.webinars.joinAsPresenter": "Ouvrir la salle (animateur)",
  "learner.webinars.join": "Rejoindre la salle",
  "learner.webinars.invitedOn": "Invité le",
  "learner.webinars.scheduledFor": "Prévu le",
  "learner.webinars.duration": "Durée : {{duration}}",
  "learner.webinars.loadError": "Impossible de charger les webinaires.",
  "learner.webinars.status.draft": "Brouillon",
  "learner.webinars.status.scheduled": "Planifié",
  "learner.webinars.status.live": "En direct",
  "learner.webinars.status.ended": "Terminé",
  "learner.sidebar.myProfile": "Mon profil",
  "learner.sidebar.logout": "Déconnexion",
  "learner.sidebar.backToTrainer": "Tableau de bord formateur",
  "learner.sidebar.backToTrainerAria": "Retour au tableau de bord formateur",
  "learner.home.defaultName": "apprenant·e",
  "learner.home.greeting": "Bonjour {{name}},",
  "learner.home.greetingSubtitle": "Reprenez votre apprentissage là où vous vous êtes arrêté·e.",
  "learner.home.resumeMyFormation": "Reprendre ma formation",
  "learner.home.globalProgress": "Progression globale",
  "learner.home.learningTime": "Temps d'apprentissage",
  "learner.home.badges": "Badges obtenus",
  "learner.home.calendarKicker": "Ma progression",
  "learner.home.quickAccess": "Accès rapides",
  "learner.learningPath": "Parcours",
  "learner.home.resumeTraining": "Reprendre vos formations",
  "learner.home.viewAll": "Voir tout →",
  "learner.home.trainingDomains": "Domaines de formation",
  "learner.home.courses": "cours",
  "learner.home.episodes": "épisodes",
  "learner.home.recommendedPodcasts": "Podcasts recommandés",
  "learner.home.explore": "Explorer →",
  "learner.formations.title": "Mes Formations",
  "learner.formations.searchPlaceholder": "Rechercher une formation…",
  "learner.formations.all": "Tous",
  "learner.formations.formation": "Formation",
  "learner.formations.inProgress": "En cours",
  "learner.formations.completed": "Terminé",
  "learner.formations.notStarted": "Non commencé",
  "learner.formations.loading": "Chargement de vos formations...",
  "learner.formations.empty": "Aucune formation trouvée.",
  "learner.formations.progress": "Progression",
  "learner.formations.instructor": "Formateur",
  "learner.formations.opening": "Ouverture...",
  "learner.formations.review": "Revoir",
  "learner.formations.start": "Commencer",
  "learner.formations.continue": "Continuer",
  "learner.podcasts.title": "Explorer les Podcasts",
  "learner.podcasts.searchPlaceholder": "Rechercher un podcast…",
  "learner.podcasts.all": "Tous",
  "learner.podcasts.assigned": "Podcast assigné",
  "learner.podcasts.defaultCategory": "Podcast",
  "learner.podcasts.loading": "Chargement de vos podcasts...",
  "learner.podcasts.empty": "Aucun podcast assigné.",
  "learner.podcasts.episodes": "épisodes",
  "learner.podcasts.opening": "Ouverture...",
  "learner.podcasts.listen": "Écouter",
  "learner.documents.title": "Documents partagés",
  "learner.documents.loading": "Chargement de vos documents...",
  "learner.documents.view": "Consulter le document",
  "learner.documents.empty": "Aucun document partagé.",
  "learner.documents.personalTitle": "Mes documents personnels",
  "learner.documents.personalHint": "Vos documents personnels ne sont visibles que par vous. Cliquez sur un document pour le consulter et poser des questions à l'assistant IA.",
  "learner.documents.personalEmpty": "Aucun document personnel. Déposez un PDF pour commencer.",
  "learner.documents.upload": "Déposer un document",
  "learner.documents.delete": "Supprimer",
  "learner.documents.deleteConfirmTitle": "Supprimer ce document ?",
  "learner.documents.deleteConfirmDesc": "Cette action est irréversible. Le document et son analyse IA seront supprimés.",
  "learner.documents.cancel": "Annuler",
  "learner.documents.confirmDelete": "Supprimer",
  "learner.documents.chatReady": "Chat disponible",
  "learner.documents.processing": "Analyse en cours…",
  "learner.documents.backToList": "Retour aux documents",
  "learner.documents.chatTitle": "Posez vos questions sur ce document",
  "learner.documents.chatPlaceholder": "Posez une question sur ce document…",
  "learner.documents.chatPlaceholderHint": "Posez n'importe quelle question sur ce document. L'assistant ne répondra qu'à partir de son contenu.",
  "learner.documents.chatError": "Une erreur est survenue.",
  "learner.documents.preview": "Aperçu",
  "learner.documents.indexing": "Analyse de votre document en cours…",
  "learner.progress.title": "Ma Progression",
  "learner.progress.completedFormations": "Formations terminées",
  "learner.progress.trainingHours": "Heures de formation",
  "learner.progress.listenedPodcasts": "Podcasts écoutés",
  "learner.progress.earnedBadges": "Badges obtenus",
  "learner.progress.weeklyActivity": "Activité de la semaine",
  "learner.progress.badges": "Badges",
  "learner.progress.recentActivity": "Activité récente",
  "learner.progress.rarity.common": "Commun",
  "learner.progress.rarity.rare": "Rare",
  "learner.progress.rarity.epic": "Épique",
  "learner.progress.rarity.legendary": "Légendaire",
  "learner.progress.days.mon": "Lun",
  "learner.progress.days.tue": "Mar",
  "learner.progress.days.wed": "Mer",
  "learner.progress.days.thu": "Jeu",
  "learner.progress.days.fri": "Ven",
  "learner.progress.days.sat": "Sam",
  "learner.progress.days.sun": "Dim",
  "learner.profile.title": "Mon Profil",
  "learner.profile.defaultName": "Apprenant",
  "learner.profile.defaultEmail": "apprenant@exemple.com",
  "learner.profile.memberSince": "Membre depuis janvier 2024",
  "learner.profile.editProfile": "Modifier le profil",
  "learner.profile.formations": "Formations",
  "learner.profile.hours": "Heures",
  "learner.profile.podcasts": "Podcasts",
  "learner.profile.badges": "Badges",
  "learner.profile.preferences": "Préférences",
  "learner.profile.theme": "Thème",
  "learner.profile.themeLight": "Clair",
  "learner.profile.themeDark": "Sombre",
  "learner.profile.themeSystem": "Système",
  "learner.profile.language": "Langue",
  "learner.profile.notifications": "Notifications",
  "learner.profile.fontSize": "Taille du texte",
  "learner.profile.fontNormal": "Normal",
  "learner.profile.fontLarge": "Grand",
  "learner.profile.highContrast": "Contraste élevé",
  "learner.profile.a11ySection": "Accessibilité",
  "learner.profile.dangerZone": "Zone de danger",
  "learner.profile.logoutBtn": "Se déconnecter",
  "learner.parcours.title": "Mes Parcours",
  "learner.parcours.assigned": "parcours assigné(s)",
  "learner.parcours.loading": "Chargement de vos parcours…",
  "learner.parcours.loadError": "Impossible de charger vos parcours.",
  "learner.parcours.noAssigned": "Aucun parcours assigné",
  "learner.parcours.noAssignedDesc": "Votre formateur vous assignera des parcours ici.",
  "learner.parcours.completedBadge": "Terminé ✓",
  "learner.parcours.by": "Par",
  "learner.parcours.contents": "contenu(s)",
  "learner.parcours.completedItems": "complété(s)",
  "learner.parcours.emptyPath": "Aucun contenu dans ce parcours.",
  "learner.parcours.locked": "Terminez le précédent d'abord",
  "learner.parcours.review": "Revoir",
  "learner.parcours.listen": "Écouter",
  "learner.parcours.open": "Ouvrir",
  "learner.modal.loading": "Chargement…",
  "learner.modal.noEpisodes": "Aucun épisode disponible.",
  "learner.modal.markedDone": "✓ Marqué comme terminé",
  "learner.modal.listenThenMark": "Écoutez puis marquez comme terminé",
  "learner.modal.alreadyDone": "Déjà terminé",
  "learner.modal.markDone": "Marquer comme terminé",
  "learner.modal.formationDone": "✓ Formation terminée",
  "learner.modal.completeThenMark": "Complétez la formation puis marquez-la comme terminée",
  "learner.modal.formationAlreadyDone": "Déjà terminée",
  "learner.modal.markFormationDone": "Marquer comme terminée",
  "learner.modal.formationInstruction": "Suivez les modules de cette formation dans l'ordre, puis marquez-la comme terminée pour progresser dans votre parcours.",
  "learner.modal.launchFormation": "Lancer la formation",
  "learner.modal.openFormationHint": "Ouvrez la formation dans un nouvel onglet, puis marquez-la comme terminée dans le parcours.",
  "learner.home.loadingHome": "Chargement de votre accueil…",
  "learner.home.noFormationsAssigned": "Aucune formation assignée pour le moment. Elles apparaîtront ici dès qu’un formateur vous en attribuera.",
  "learner.home.loadingPaths": "Chargement de vos parcours…",
  "learner.home.noPathsAssigned": "Aucun parcours assigné pour le moment. Ils apparaîtront ici dès qu’un formateur vous en attribuera.",
  "learner.home.byTheme": "Vos contenus par thème",
  "learner.home.themesHint": "Les thèmes apparaissent à partir des catégories de vos formations et podcasts assignés.",
  "learner.home.categoryOther": "Autres",
  "learner.home.contentsCount_one": "{{count}} contenu",
  "learner.home.contentsCount_other": "{{count}} contenus",
  "learner.home.viewThemeFormations": "Voir les {{count}} formations du thème",
  "learner.home.viewThemePodcasts": "Voir les {{count}} podcasts du thème",
  "learner.home.resumeSubtitleProgress": "Progression {{percent}} %",
  "learner.home.resumeSubtitleNotStarted": "Pas encore commencé",
  "learner.home.podcastsAssigned": "Podcasts assignés",
  "learner.home.viewAllPodcasts": "Tout voir →",
  "learner.home.gamificationHomeHint": "Le détail des badges et de l’activité est dans l’onglet « Ma progression ».",
  "learner.home.gamificationHomeCta": "Ouvrir ma progression",
  "learner.podcasts.mineTitle": "Mes podcasts",
  "learner.podcasts.episodeCount_one": "{{count}} épisode",
  "learner.podcasts.episodeCount_other": "{{count}} épisodes",
  "learner.progress.loading": "Chargement de votre progression…",
  "learner.progress.statPodcastsCompleted": "Podcasts terminés",
  "learner.progress.statTimeFormationsHours": "Temps sur les formations (h)",
  "learner.progress.statAssignedContents": "Contenus assignés",
  "learner.progress.weeklyEstimated": "Activité des 7 derniers jours (estimée)",
  "learner.progress.badgesSoon": "Les badges et récompenses seront bientôt disponibles dans votre espace.",
  "learner.progress.gamificationSection": "Niveau et expérience",
  "learner.progress.gamificationLevelLine": "Niveau {{level}} — {{name}}",
  "learner.progress.gamificationXpToNext": "Encore {{xp}} XP pour le niveau suivant",
  "learner.progress.rewardFormation": "Formation terminée",
  "learner.progress.rewardPathItem": "Étape de parcours",
  "learner.progress.rewardPathComplete": "Parcours terminé",
  "learner.progress.rewardDesignerBlocks": "Points formation (blocs)",
  "learner.progress.rewardDesignerPerfect": "Bonus score parfait",
  "learner.progress.rewardDesignerBadge": "Badge formation",
  "learner.progress.rewardDesignerBadgeNoXp": "Sans points XP (récompense visuelle)",
  "learner.progress.badgesEmpty": "Complétez une formation ou un parcours pour gagner des points et voir vos récompenses ici.",
  "learner.progress.plusXp": "+{{xp}} XP",
  "learner.progress.noRecentHint": "Aucune activité récente enregistrée. Ouvrez une formation ou un podcast pour alimenter ce fil.",
  "learner.progress.hoursShort": "{{hours}} h",
  "learner.profile.statFormationsRatio": "Formations (terminées / total)",
  "learner.profile.statTimeFormations": "Temps formations (h)",
  "learner.profile.statPodcastsAssigned": "Podcasts assignés",
  "learner.profile.statPathsAssigned": "Parcours assignés",
  "learner.profile.memberSincePrefix": "Membre depuis {{date}}",
  "learner.parcours.playPath": "Suivre ce parcours",
  "learner.parcours.playPathTitle": "Ouvre le parcours en plein écran dans un nouvel onglet",
  "learner.parcours.steps_zero": "Aucune étape",
  "learner.parcours.steps_one": "1 étape",
  "learner.parcours.steps_other": "{{count}} étapes",
  "learner.parcours.doneBadge": "Terminé",
  "learner.parcours.completedSingle": "{{done}}/{{total}} complétée",
  "learner.parcours.completedPlural": "{{done}}/{{total}} complétées",
  "learner.parcours.byAuthor": "Par {{firstName}} {{lastName}}",
  "learner.parcours.pathListAria": "Liste de vos parcours",
  "learner.parcours.assignedCount_one": "{{count}} parcours assigné",
  "learner.parcours.assignedCount_other": "{{count}} parcours assignés",
  "learner.pathPlayer.loading": "Chargement du parcours…",
  "learner.pathPlayer.errorGeneric": "Erreur",
  "learner.pathPlayer.pathNotFound": "Parcours introuvable",
  "learner.pathPlayer.loadError": "Impossible de charger le parcours.",
  "learner.pathPlayer.backToPaths": "Retour aux parcours",
  "learner.pathPlayer.showTocAria": "Afficher le sommaire",
  "learner.pathPlayer.prevActivityAria": "Activité précédente",
  "learner.pathPlayer.prev": "Précédent",
  "learner.pathPlayer.nextActivityAria": "Activité suivante",
  "learner.pathPlayer.next": "Suivant",
  "learner.pathPlayer.closePlayerTitle": "Fermer et retourner aux parcours",
  "learner.pathPlayer.close": "Fermer",
  "learner.pathPlayer.congrats": "Félicitations",
  "learner.pathPlayer.pathCompleteTitle": "Parcours terminé",
  "learner.pathPlayer.pathCompleteBody": "Vous avez terminé toutes les activités du parcours « {{title}} ».",
  "learner.pathPlayer.activitiesCompleted_one": "{{count}} activité accomplie",
  "learner.pathPlayer.activitiesCompleted_other": "{{count}} activités accomplies",
  "learner.pathPlayer.seeMyPaths": "Voir mes parcours",
  "learner.pathPlayer.closeTocAria": "Fermer le sommaire",
  "learner.pathPlayer.tocNavAria": "Sommaire du parcours",
  "learner.pathPlayer.pathTypeLabel": "Parcours de formation",
  "learner.pathPlayer.noDescription": "Aucune description.",
  "learner.pathPlayer.activityCount_zero": "Aucune activité",
  "learner.pathPlayer.activityCount_one": "1 activité",
  "learner.pathPlayer.activityCount_other": "{{count}} activités",
  "learner.pathPlayer.progressPercent": "Progression {{percent}}%",
  "learner.pathPlayer.quit": "Quitter",
  "learner.pathPlayer.summary": "Sommaire",
  "learner.pathPlayer.outsideModule": "Hors module",
  "learner.pathPlayer.moduleContents": "Contenus du module",
  "learner.pathPlayer.step": "Étape",
  "learner.pathPlayer.podcastHint": "Écoutez l’épisode, puis marquez l’activité comme terminée.",
  "learner.pathPlayer.showChapters": "Afficher les chapitres",
  "learner.pathPlayer.hideChapters": "Masquer les chapitres",
  "learner.pathPlayer.showText": "Afficher le texte",
  "learner.pathPlayer.hideText": "Masquer le texte",
  "learner.pathPlayer.selectEpisode": "Sélectionnez un épisode pour commencer.",
  "learner.pathPlayer.loadingShort": "Chargement…",
  "learner.pathPlayer.noEpisodes": "Aucun épisode disponible.",
  "learner.pathPlayer.listenThenMark": "Écoutez puis marquez comme terminé",
  "learner.pathPlayer.updating": "Mise à jour…",
  "learner.pathPlayer.alreadyDone": "Déjà terminé",
  "learner.pathPlayer.markComplete": "Marquer comme terminé",
  "learner.pathPlayer.nextStepBtn": "Étape suivante",
  "learner.pathPlayer.embeddedFormationHint": "La formation s’affiche ci-dessous dans le parcours. Utilisez le sommaire à gauche pour les étapes détaillées.",
  "learner.pathPlayer.loadingFormation": "Chargement de la formation…",
  "learner.pathPlayer.loadingReader": "Chargement du lecteur…",
  "learner.pathPlayer.emptyPathTitle": "Ce parcours ne contient pas encore d’activités.",
  "learner.pathPlayer.emptyPathDesc": "Le contenu sera ajouté par votre organisme de formation. Vous pouvez fermer cette fenêtre et revenir plus tard.",
  "learner.pathPlayer.pickActivity": "Choisissez une activité dans le sommaire pour commencer.",
  "learner.pathPlayer.footerStep": "Étape {{current}} / {{total}}",
  "learner.pathPlayer.unmute": "Activer le son",
  "learner.pathPlayer.mute": "Couper le son",
  "learner.activity.flowCompleted": "Formation « {{title}} » terminée",
  "learner.activity.flowProgress": "Formation « {{title}} » — {{progress}} %",
  "learner.activity.podcast": "Podcast « {{title}} »",
  "learner.webinars.durationMin": "{{m}} min",
  "learner.webinars.durationH": "{{h}} h",
  "learner.webinars.durationHM": "{{h}} h {{m}}",
  "learner.formations.durationHours": "{{hours}} h",
  "rh.dashboard.title": "Tableau de bord RH",
  "rh.dashboard.subtitle": "Vue d’ensemble formation & développement des compétences",
  "rh.dashboard.activeCampaigns": "Campagnes actives",
  "rh.dashboard.pendingAssignmentsKpi": "Assignations (en attente / acceptées)",
  "rh.dashboard.pendingRequestsCount": "Demandes en attente",
  "rh.dashboard.completionRateLabel": "Taux de complétion (parcours)",
  "rh.dashboard.budgetUsed": "Budget campagnes utilisé",
  "rh.dashboard.budgetNotSet": "Non renseigné",
  "rh.dashboard.progressLabel": "Progression (%)",
  "rh.dashboard.chartCampaignsTitle": "Progression des campagnes",
  "rh.dashboard.chartFormationsTitle": "Progression des parcours (inscriptions)",
  "rh.dashboard.campaignProgress": "Avancement des campagnes",
  "rh.dashboard.chartCampaignsHint": "Taux moyen d’avancement des assignations par campagne.",
  "rh.dashboard.chartFormationsHint": "Part d’apprenants ayant terminé le parcours (sur inscriptions en cours).",
  "rh.dashboard.upcomingDeadlines": "Échéances à venir",
  "rh.dashboard.recentActivity": "Activité récente",
  "rh.dashboard.recentActivityHint": "Assignations de campagnes et parcours terminés.",
  "rh.dashboard.viewAll": "Tout voir",
  "rh.dashboard.exportReport": "Exporter le rapport",
  "rh.dashboard.exportSoon": "Export disponible prochainement.",
  "rh.dashboard.newCampaign": "Nouvelle campagne",
  "rh.dashboard.createCampaign": "Créer une campagne",
  "rh.dashboard.reviewRequests": "Traiter les demandes",
  "rh.dashboard.skillsMap": "Référentiel compétences",
  "rh.dashboard.budgetOverview": "Vue budget",
  "rh.dashboard.loadError": "Impossible de charger le pilotage RH.",
  "rh.dashboard.emptyChart": "Aucune donnée à afficher pour cette période.",
  "rh.dashboard.emptyDeadlines": "Aucune échéance de campagne à venir.",
  "rh.dashboard.emptyRecent": "Aucune activité récente.",
  "rh.dashboard.kindAssignment": "Campagne",
  "rh.dashboard.kindCompletion": "Parcours terminé",
  "rh.dashboard.justNow": "À l'instant",
  "rh.dashboard.learnerInsightTitle": "Pilotage formations (données réelles)",
  "rh.dashboard.learnerInsightHint": "Inscriptions aux formations agrégées : scores issus des blocs notés, friction par bloc, dernières évaluations.",
  "rh.dashboard.enrollmentsTotal": "Inscriptions",
  "rh.dashboard.completionGlobal": "Complétés",
  "rh.dashboard.avgTimePerEnrollment": "Temps moyen / inscription",
  "rh.dashboard.notStarted": "Non démarrés",
  "rh.dashboard.stalled": "En pause (>30 j. sans activité après début)",
  "rh.dashboard.topFlowsDetail": "Parcours les plus suivis",
  "rh.dashboard.colFlow": "Parcours",
  "rh.dashboard.colEnrolled": "Inscrits",
  "rh.dashboard.colCompletedPct": "Complétion",
  "rh.dashboard.colAvgTime": "Temps moyen",
  "rh.dashboard.colAvgScore": "Score moy.",
  "rh.dashboard.blockFrictionTitle": "Blocs les plus frictionnels (sessions ≥3)",
  "rh.dashboard.colBlock": "Bloc",
  "rh.dashboard.colSessions": "Sessions",
  "rh.dashboard.colBlockCompletion": "Complétion bloc",
  "rh.dashboard.recentEvalTitle": "Dernières évaluations",
  "rh.dashboard.evalComment": "Commentaire",
  "rh.dashboard.exportOk": "Export CSV téléchargé.",
  "rh.dashboard.exportFail": "Échec du téléchargement.",
  "institution.dashboard.trainingCardTitle": "Suivi formations (inscriptions)",
  "institution.dashboard.trainingCardHint": "Vue agrégée sur tous les parcours de l’établissement.",
  "institution.dashboard.trainingCompleted": "parcours terminés",
  "institution.dashboard.trainingAvgMinutes": "min moy. / inscription",
  "rh.status.urgent": "Urgent",
  "rh.status.soon": "Proche",
  "rh.status.upcoming": "À venir",
  "rh.status.pending": "En cours",
  "rh.status.approved": "Terminé",
  "rh.status.rejected": "Annulé",
  "admin.nav.stats": "Statistiques",
  "admin.nav.users": "Utilisateurs",
  "admin.nav.support": "Support et chat",
  "admin.nav.institutions": "Établissements",
  "admin.nav.contracts": "Contrats",
  "admin.nav.editors": "Éditeurs",
  "admin.nav.podcasts": "Podcasts",
  "admin.nav.sounds": "Sons Lyrra",
  "admin.nav.templates": "Templates formations",
  "admin.nav.demoFormations": "Formations démo",
  "admin.nav.templatesImages": "Modèles d’image",
  "admin.nav.tools": "Outils",
  "admin.nav.files": "Fichiers",
  "admin.nav.logs": "Journaux",
  "admin.nav.webhooks": "Webhooks",
  "admin.nav.email": "Email",
  "admin.nav.docusign": "DocuSign",
  "admin.docusign.title": "Intégration DocuSign",
  "admin.docusign.subtitle": "Clé d’intégration, identifiants API et clé privée RSA (JWT). Stockés en base, plus dans Docker.",
  "admin.docusign.statusOk": "Configuré",
  "admin.docusign.statusIncomplete": "Incomplet",
  "admin.docusign.keyStored": "Clé privée enregistrée",
  "admin.docusign.consentHint": "Pour la première utilisation JWT, le compte DocuSign doit avoir accepté le consentement d’application (URL fournie par DocuSign). En cas d’erreur 401/403, vérifiez la clé PEM, la clé d’intégration et ce consentement.",
  "admin.docusign.loading": "Chargement…",
  "admin.docusign.loadError": "Impossible de charger la configuration DocuSign",
  "admin.docusign.saved": "Paramètres DocuSign enregistrés",
  "admin.docusign.saveError": "Enregistrement impossible",
  "admin.docusign.save": "Enregistrer",
  "admin.docusign.reload": "Recharger",
  "admin.docusign.fieldIntegrationKey": "Clé d’intégration (ID client / client ID)",
  "admin.docusign.fieldUserId": "Identifiant utilisateur DocuSign (GUID)",
  "admin.docusign.fieldAccountId": "Identifiant de compte (account ID)",
  "admin.docusign.fieldBasePath": "URL de base de l’API REST",
  "admin.docusign.fieldOauthHost": "Hôte OAuth (sans https://)",
  "admin.docusign.fieldRsa": "Clé privée RSA (PEM)",
  "admin.docusign.oauthPlaceholder": "account-d.docusign.com",
  "admin.docusign.rsaPlaceholderKeep": "Laisser vide pour conserver la clé actuelle",
  "admin.docusign.rsaPlaceholderNew": "Collez le fichier .pem complet (BEGIN … END)",
  "admin.smtp.cardTitle": "Envoi des emails (SMTP)",
  "admin.smtp.subtitle": "Hôte, port, authentification et expéditeur. Stocké en base — plus de variables Docker SMTP_* ni EMAIL_FROM.",
  "admin.smtp.host": "Serveur SMTP (hôte)",
  "admin.smtp.port": "Port",
  "admin.smtp.secure": "TLS/SSL (port 465)",
  "admin.smtp.user": "Utilisateur",
  "admin.smtp.password": "Mot de passe",
  "admin.smtp.passwordPlaceholder": "Laisser vide pour conserver le mot de passe actuel",
  "admin.smtp.passwordPlaceholderNew": "Mot de passe SMTP",
  "admin.smtp.fromEmail": "Email expéditeur",
  "admin.smtp.fromName": "Nom affiché (From)",
  "admin.smtp.hint": "La plupart des fournisseurs exigent utilisateur + mot de passe. Testez via les outils admin (email de test) après enregistrement.",
  "admin.smtp.save": "Enregistrer SMTP",
  "admin.smtp.saved": "Paramètres SMTP enregistrés",
  "admin.smtp.saveError": "Enregistrement impossible",
  "admin.smtp.loadError": "Impossible de charger SMTP",
  "admin.smtp.loading": "Chargement…",
  "admin.smtp.configured": "Paramètres enregistrés",
  "admin.smtp.notConfigured": "À compléter",
  "admin.nav.smtp": "Configuration SMTP",
  "admin.nav.regulatoryWatch": "Veille Lyrra",
  "admin.nav.leBref": "Le Bref",
  "admin.nav.helpCenter": "Centre d'aide",
  "admin.nav.platform": "Intégrations plateforme",
  "admin.nav.eduflowPalette": "Palette EduFlow",
  "admin.users.adminScopeTitle": "Périmètre du tableau d’administration",
  "admin.users.adminScopeFull": "Accès complet (tous les onglets)",
  "admin.users.adminScopeRestricted": "Limiter aux onglets cochés",
  "admin.users.adminScopeHint": "Un compte restreint ne voit que les sections sélectionnées. Après modification des onglets, la personne doit se reconnecter (ou rafraîchir sa session) pour que le menu et les appels API reflètent le changement.",
  "admin.users.adminScopeNeedOne": "Cochez au moins un onglet, ou choisissez l’accès complet.",
  "admin.helpCenter.title": "Centre d'aide",
  "admin.helpCenter.subtitle": "Rubriques affichées en tête sur /aide et /help : catégorie, titre, texte d’introduction et lien (chemin /… ou URL https) ouvert au clic sur la fiche.",
  "admin.helpCenter.reload": "Actualiser",
  "admin.helpCenter.loadError": "Chargement impossible.",
  "admin.helpCenter.saveError": "Enregistrement impossible.",
  "admin.helpCenter.deleteError": "Suppression impossible.",
  "admin.helpCenter.saved": "Enregistré",
  "admin.helpCenter.deleted": "Supprimé",
  "admin.helpCenter.catCreated": "Catégorie créée",
  "admin.helpCenter.topicCreated": "Fiche créée",
  "admin.helpCenter.catTitleRequired": "Titre de catégorie obligatoire.",
  "admin.helpCenter.topicFieldsRequired": "Titre et lien formation obligatoires.",
  "admin.helpCenter.newCategory": "Nouvelle catégorie",
  "admin.helpCenter.createCategory": "Nouvelle catégorie",
  "admin.helpCenter.editCategory": "Modifier la catégorie",
  "admin.helpCenter.createTopic": "Nouvelle fiche",
  "admin.helpCenter.editTopic": "Modifier la fiche",
  "admin.helpCenter.fieldTitle": "Titre",
  "admin.helpCenter.fieldDescription": "Description",
  "admin.helpCenter.fieldIconKey": "Icône Lucide",
  "admin.helpCenter.fieldIconKeyHint": "Choisissez une icône ; un aperçu s’affiche dans la liste et sur le bouton.",
  "admin.helpCenter.fieldFormationUrl": "Lien formation",
  "admin.helpCenter.formationPickPlaceholder": "— Choisir une formation publique —",
  "admin.helpCenter.formationPickHint": "Seuls les parcours publiés avec l’accès public sans compte activé sont proposés.",
  "admin.helpCenter.formationPickLoading": "Chargement des parcours…",
  "admin.helpCenter.publicFlowsLoadError": "Impossible de charger la liste des parcours publics.",
  "admin.helpCenter.legacyFormationPickLabel": "Lien enregistré (hors liste)",
  "admin.helpCenter.fieldSort": "Ordre",
  "admin.helpCenter.fieldActive": "Visible",
  "admin.helpCenter.save": "Enregistrer",
  "admin.helpCenter.edit": "Modifier",
  "admin.helpCenter.addTopic": "Fiche",
  "admin.helpCenter.empty": "Aucune catégorie. Créez une catégorie puis des fiches.",
  "admin.helpCenter.noTopics": "Aucune fiche dans cette catégorie.",
  "admin.helpCenter.badgeActive": "Actif",
  "admin.helpCenter.badgeInactive": "Masqué",
  "admin.helpCenter.iconLabel": "Icône",
  "admin.helpCenter.confirmDeleteCategory": "Supprimer cette catégorie et toutes ses fiches ?",
  "admin.helpCenter.confirmDeleteTopic": "Supprimer cette fiche ?",
  "admin.nav.formationMigration": "Migration formations",
  "admin.nav.formationDuplicate": "Duplication formations",
  "admin.nav.lyrraOneFormations": "Formations LyrraOne",
  "admin.lyrraOneFormations.title": "Formations gérées par LyrraOne",
  "admin.lyrraOneFormations.subtitle": "Assignez un parcours à LyrraOne : le propriétaire technique est réassigné (compte défini par PLATFORM_EDUFLOW_OWNER_USER_ID ou premier administrateur plateforme), les collaborateurs sont retirés, et seuls les administrateurs peuvent modifier le parcours dans le designer.",
  "admin.lyrraOneFormations.searchLabel": "Recherche (titre ou ID du parcours)",
  "admin.lyrraOneFormations.searchPlaceholder": "Ex. onboarding ou UUID…",
  "admin.lyrraOneFormations.search": "Rechercher",
  "admin.lyrraOneFormations.searchMin": "Saisissez au moins 2 caractères.",
  "admin.lyrraOneFormations.results": "Résultats",
  "admin.lyrraOneFormations.noResults": "Aucun parcours trouvé.",
  "admin.lyrraOneFormations.badge": "LyrraOne",
  "admin.lyrraOneFormations.detailHint": "Le créateur et les anciens collaborateurs perdent l’accès en édition. Les apprenants et le lecteur public ne sont pas impactés.",
  "admin.lyrraOneFormations.assign": "Assigner à LyrraOne",
  "admin.lyrraOneFormations.alreadyAssigned": "Déjà assignée à LyrraOne",
  "admin.lyrraOneFormations.confirm": "Confirmer l’assignation à LyrraOne ? Cette action est irréversible depuis cet écran : le parcours ne pourra plus être modifié que par les administrateurs plateforme.",
  "admin.lyrraOneFormations.success": "Parcours « {{title}} » : assignation LyrraOne effectuée.",
  "admin.lyrraOneFormations.assignedListTitle": "Parcours déjà assignés à LyrraOne",
  "admin.lyrraOneFormations.assignedListEmpty": "Aucun parcours pour l’instant. Utilisez la recherche ci-dessous pour en assigner un.",
  "admin.lyrraOneFormations.refreshList": "Actualiser la liste",
  "admin.lyrraOneFormations.openDesigner": "Designer",
  "admin.lyrraOneFormations.assignSectionTitle": "Rechercher et assigner un autre parcours",
  "admin.lyrraOneFormations.publicPolicyHint": "Les parcours assignés à LyrraOne sont automatiquement publiés, accessibles sans compte (lien /f/…) et adaptés au partage (QR, iframe centre d’aide).",
  "admin.lyrraOneFormations.drawerTitle": "Lien public & QR code",
  "admin.lyrraOneFormations.publicShortLink": "Lien court (recommandé)",
  "admin.lyrraOneFormations.publicLongLink": "Lien lecteur public (UUID)",
  "admin.lyrraOneFormations.copy": "Copier",
  "admin.lyrraOneFormations.copied": "Copié dans le presse-papiers.",
  "admin.lyrraOneFormations.copyFailed": "Impossible de copier (navigateur ou permissions).",
  "admin.lyrraOneFormations.publicLinksUnavailable": "Liens indisponibles : publiez l’accès public ou utilisez « Mettre à jour l’accès public » si le parcours date d’avant cette règle.",
  "admin.lyrraOneFormations.publicIncomplete": "Accès public incomplet",
  "admin.lyrraOneFormations.publicRepairHint": "Ce parcours est géré LyrraOne mais n’a pas encore les réglages publics complets (publication, accès anonyme, code court).",
  "admin.lyrraOneFormations.publicRepairCta": "Mettre à jour l’accès public",
  "admin.lyrraOneFormations.publicRepairOk": "Accès public appliqué pour « {{title}} ».",
  "admin.formationDuplicate.title": "Dupliquer une formation vers un autre établissement",
  "admin.formationDuplicate.subtitle": "Recherchez un parcours, choisissez l’établissement et le compte propriétaire de la copie. Le parcours d’origine reste inchangé. La copie est un brouillon (sans catalogue, sessions ni collaborateurs).",
  "admin.formationDuplicate.searchLabel": "Recherche (titre ou ID du parcours)",
  "admin.formationDuplicate.searchPlaceholder": "Ex. onboarding ou UUID…",
  "admin.formationDuplicate.search": "Rechercher",
  "admin.formationDuplicate.searchMin": "Saisissez au moins 2 caractères.",
  "admin.formationDuplicate.results": "Résultats",
  "admin.formationDuplicate.noResults": "Aucun parcours trouvé.",
  "admin.formationDuplicate.currentOwner": "Propriétaire actuel",
  "admin.formationDuplicate.currentInstitution": "Établissement d’origine",
  "admin.formationDuplicate.targetInstitution": "Établissement de la copie",
  "admin.formationDuplicate.pickInstitution": "Choisir un établissement…",
  "admin.formationDuplicate.newOwner": "Propriétaire de la copie (formateur / RH)",
  "admin.formationDuplicate.pickOwner": "Choisir un compte…",
  "admin.formationDuplicate.noCandidates": "Aucun compte éligible dans cet établissement.",
  "admin.formationDuplicate.duplicate": "Dupliquer la formation",
  "admin.formationDuplicate.confirm": "Créer une copie de cette formation pour le compte sélectionné ? Le parcours source ne sera pas modifié.",
  "admin.formationDuplicate.success": "Copie créée : « {{title}} » pour {{email}}. Identifiant du nouveau parcours : {{newFlowId}}.",
  "admin.formationDuplicate.loadInstitutionsError": "Impossible de charger la liste des établissements.",
  "admin.formationDuplicate.loadCandidatesError": "Impossible de charger les comptes éligibles.",
  "admin.formationMigration.title": "Migrer une formation entre établissements",
  "admin.formationMigration.subtitle": "Recherchez un parcours EduFlow, choisissez l’établissement cible et un compte pouvant en être propriétaire (formateur, RH, etc.). Les collaborateurs et catégories du parcours sont retirés ; les liens catalogue, campagnes et compétences de l’ancien établissement sont coupés.",
  "admin.formationMigration.searchLabel": "Recherche (titre ou ID du parcours)",
  "admin.formationMigration.searchPlaceholder": "Ex. onboarding ou UUID…",
  "admin.formationMigration.search": "Rechercher",
  "admin.formationMigration.searchMin": "Saisissez au moins 2 caractères.",
  "admin.formationMigration.results": "Résultats",
  "admin.formationMigration.noResults": "Aucun parcours trouvé.",
  "admin.formationMigration.currentOwner": "Propriétaire actuel",
  "admin.formationMigration.currentInstitution": "Établissement d’origine",
  "admin.formationMigration.targetInstitution": "Établissement cible",
  "admin.formationMigration.pickInstitution": "Choisir un établissement…",
  "admin.formationMigration.newOwner": "Nouveau propriétaire (formateur / RH)",
  "admin.formationMigration.pickOwner": "Choisir un compte…",
  "admin.formationMigration.noCandidates": "Aucun compte éligible dans cet établissement.",
  "admin.formationMigration.migrate": "Migrer la formation",
  "admin.formationMigration.confirm": "Confirmer la migration ? Les collaborateurs et catégories seront retirés, les liens RH/catalogue incohérents seront supprimés ou déliés.",
  "admin.formationMigration.success": "Migration effectuée : « {{title}} » est désormais attribuée à {{email}}.",
  "admin.formationMigration.clearedCatalog": "Lien fiche catalogue retiré (fiche d’un autre établissement).",
  "admin.formationMigration.loadInstitutionsError": "Impossible de charger la liste des établissements.",
  "admin.formationMigration.loadCandidatesError": "Impossible de charger les comptes éligibles.",
  "admin.regulatoryWatch.title": "Veille — alertes LyrraOne",
  "admin.regulatoryWatch.subtitle": "Publie une alerte sur la timeline « Veille réglementaire » de tous les établissements actifs. Le contenu est verrouillé côté OF ; ils peuvent accuser réception, annoter et planifier une action.",
  "admin.regulatoryWatch.refresh": "Actualiser",
  "admin.regulatoryWatch.loadError": "Chargement impossible.",
  "admin.regulatoryWatch.validationRequired": "Titre, description et source sont obligatoires.",
  "admin.regulatoryWatch.publishError": "Publication impossible.",
  "admin.regulatoryWatch.newBroadcastTitle": "Nouvelle alerte globale",
  "admin.regulatoryWatch.placeholderTitle": "Titre",
  "admin.regulatoryWatch.placeholderDescription": "Description (visible par tous les OF)",
  "admin.regulatoryWatch.placeholderSource": "Lien ou référence source",
  "admin.regulatoryWatch.category.reglementaire": "Réglementaire",
  "admin.regulatoryWatch.category.pedagogique": "Pédagogique",
  "admin.regulatoryWatch.category.technique": "Technique",
  "admin.regulatoryWatch.category.sectoriel": "Sectoriel",
  "admin.regulatoryWatch.impact.fort": "Impact fort",
  "admin.regulatoryWatch.impact.moyen": "Impact moyen",
  "admin.regulatoryWatch.impact.faible": "Impact faible",
  "admin.regulatoryWatch.publishing": "Publication…",
  "admin.regulatoryWatch.publishButton": "Publier sur tous les établissements actifs",
  "admin.regulatoryWatch.historyTitle": "Historique & accusés de réception",
  "admin.regulatoryWatch.loading": "Chargement…",
  "admin.regulatoryWatch.empty": "Aucune alerte publiée pour le moment.",
  "admin.regulatoryWatch.institutionsCount": "{{count}} établissement(s)",
  "admin.regulatoryWatch.ackProgress": "Pris en compte : {{ack}}/{{total}} ({{pct}}%)",
  "admin.regulatoryWatch.byAuthor": "Par {{who}}",
  "admin.regulatoryWatch.unknownAuthor": "—",
  "admin.leBref.title": "Le Bref — calendrier publication",
  "admin.leBref.subtitle": "Brief quotidien affiché sur la page publique /le-bref. Un seul brief « publié » par jour calendaire.",
  "admin.leBref.refresh": "Actualiser",
  "admin.leBref.loadError": "Chargement impossible.",
  "admin.leBref.validationTitle": "Le titre est obligatoire.",
  "admin.leBref.validationBlocks": "Ajoutez au moins un bloc (texte, audio, quiz ou sondage).",
  "admin.leBref.validationBlocksInvalid": "Aucun bloc valide : vérifiez les quiz (question + 2 réponses minimum, bonne réponse cohérente), les URL audio, et du texte non vide.",
  "admin.leBref.blocksHint": "Composez le brief avec des blocs (texte, médias, quiz, sondage sans HTML). Les anciens briefs au format HTML sont convertis à l’ouverture.",
  "admin.leBref.block.text": "Texte",
  "admin.leBref.block.audio": "Audio",
  "admin.leBref.block.quiz": "Quiz",
  "admin.leBref.block.poll": "Sondage",
  "admin.leBref.blocksEmpty": "Ajoutez des blocs (texte, audio, quiz, sondage). Plus besoin de saisir du HTML.",
  "admin.leBref.block.moveUp": "Monter",
  "admin.leBref.block.moveDown": "Descendre",
  "admin.leBref.block.remove": "Supprimer le bloc",
  "admin.leBref.block.textPlaceholder": "Paragraphe (texte brut ou sauts de ligne)",
  "admin.leBref.block.audioUrl": "URL du fichier audio",
  "admin.leBref.block.audioCaption": "Légende (optionnel)",
  "admin.leBref.block.quizQuestion": "Question",
  "admin.leBref.block.quizOptions": "Réponses",
  "admin.leBref.block.optionLabel": "Option",
  "admin.leBref.block.addOption": "Ajouter une réponse",
  "admin.leBref.block.quizFeedback": "Feedback après validation (optionnel)",
  "admin.leBref.block.pollQuestion": "Question du sondage",
  "admin.leBref.block.pollMulti": "Choix multiples",
  "admin.leBref.block.image": "Image",
  "admin.leBref.block.video": "Vidéo",
  "admin.leBref.block.imageUrl": "URL de l’image (HTTPS ou média hébergé)",
  "admin.leBref.block.imageAlt": "Texte alternatif (accessibilité)",
  "admin.leBref.block.imageCaption": "Légende affichée sous l’image (optionnel)",
  "admin.leBref.block.videoHint": "Lien YouTube, Vimeo ou URL directe vers une vidéo (mp4, WebM…), comme dans le designer.",
  "admin.leBref.block.videoUrl": "URL de la vidéo",
  "admin.leBref.block.videoPoster": "Image d’affiche (poster), URL optionnelle — surtout pour les fichiers vidéo directs",
  "admin.leBref.block.videoCaption": "Titre ou légende (optionnel)",
  "admin.leBref.block.audioTtsHint": "Le texte est lu par Mistral TTS ; la voix est choisie automatiquement selon la langue du texte (comme pour les blocs audio du designer).",
  "admin.leBref.block.audioTtsPlaceholder": "Texte à lire à voix haute…",
  "admin.leBref.block.audioTtsGenerate": "Synthétiser (Mistral TTS)",
  "admin.leBref.block.audioTtsReady": "Audio prêt — sera régénéré à l’enregistrement si le texte change.",
  "admin.leBref.block.audioUrlReadonly": "Fichier audio",
  "admin.leBref.block.audioPreviewUnsupported": "Aperçu non supporté",
  "admin.leBref.block.audioTtsNeedText": "Saisissez d’abord le texte à lire.",
  "admin.leBref.block.audioTtsBadResponse": "Réponse TTS invalide.",
  "admin.leBref.block.audioTtsError": "Synthèse impossible (Mistral TTS / intégrations).",
  "admin.leBref.saveError": "Enregistrement impossible.",
  "admin.leBref.deleteError": "Suppression impossible.",
  "admin.leBref.confirmDelete": "Supprimer ce brief ?",
  "admin.leBref.quizJsonInvalid": "JSON du quiz invalide.",
  "admin.leBref.aiError": "Génération IA impossible (clé Mistral / intégrations plateforme).",
  "admin.leBref.prevMonth": "Mois précédent",
  "admin.leBref.nextMonth": "Mois suivant",
  "admin.leBref.legend": "Légende",
  "admin.leBref.status.published": "Publié",
  "admin.leBref.status.draft": "Brouillon",
  "admin.leBref.status.archived": "Archivé",
  "admin.leBref.clickDayHint": "Cliquez un jour pour préparer un nouveau brief à cette date.",
  "admin.leBref.editBrief": "Modifier le brief",
  "admin.leBref.newBrief": "Nouveau brief",
  "admin.leBref.aiBlockTitle": "Assistant IA (Mistral)",
  "admin.leBref.aiThemePlaceholder": "Thème ou consigne (ex. résumé + quiz, sondage pratiques RH, URL article, lien YouTube…)",
  "admin.leBref.aiContextHint": "Précisez l’objectif : résumé, quiz, sondage d’avis, version audio, ou collez une URL / un lien image ou vidéo — l’IA adapte les types de blocs (texte, audio, image, vidéo, quiz, sondage).",
  "admin.leBref.aiGenerate": "Remplir avec l’IA",
  "admin.leBref.titlePlaceholder": "Titre",
  "admin.leBref.excerptPlaceholder": "Chapô / extrait court",
  "admin.leBref.bodyPlaceholder": "Corps (HTML autorisé : p, strong, em, ul, li, br)",
  "admin.leBref.audioUrlPlaceholder": "URL audio optionnelle (mp3, etc.)",
  "admin.leBref.quizPlaceholder": "Quiz JSON optionnel : {\"questions\":[{\"question\":\"…\",\"options\":[\"A\",\"B\",\"C\",\"D\"],\"correctIndex\":0,\"feedback\":\"…\"}]}",
  "admin.leBref.save": "Enregistrer",
  "admin.leBref.create": "Créer",
  "admin.leBref.resetForm": "Nouveau / effacer",
  "admin.leBref.delete": "Supprimer",
  "admin.leBref.monthListTitle": "Briefs du mois",
  "admin.leBref.loading": "Chargement…",
  "admin.leBref.emptyMonth": "Aucun brief sur cette période.",
  "admin.leBref.edit": "Éditer",
  "admin.support.title": "Conversations support",
  "admin.support.loadError": "Impossible de charger les conversations.",
  "admin.support.replyError": "Impossible d'envoyer la réponse.",
  "admin.support.selectThread": "Sélectionnez une conversation pour voir les messages.",
  "admin.support.replyPlaceholder": "Votre réponse à l’utilisateur…",
  "admin.support.sendReply": "Envoyer",
  "admin.support.refresh": "Actualiser",
  "admin.support.user": "Utilisateur",
  "admin.support.subject": "Sujet",
  "admin.support.status": "Statut",
  "admin.support.priority": "Priorité",
  "admin.support.updated": "Mise à jour",
  "admin.support.messages": "Fil de discussion",
  "admin.support.newestFirst": "plus récent en haut",
  "admin.support.allStatuses": "Tous les statuts",
  "admin.support.linearCreate": "Créer un ticket Linear",
  "admin.support.linearOpen": "Ouvrir dans Linear",
  "admin.support.linearError": "Impossible de créer le ticket Linear. Vérifiez LINEAR_API_KEY sur le serveur.",
  "podcasts.pdfImport.openButton": "Importer un document",
  "podcasts.pdfImport.pickPodcastTitle": "Choisir le podcast cible",
  "podcasts.pdfImport.noPodcast": "Créez d’abord un podcast non archivé pour importer un document.",
  "podcasts.pdfImport.noPodcastMatch": "Aucun podcast ne correspond à la recherche.",
  "podcasts.list.actionImportDocument": "Importer un document (PDF ou Markdown)",
  "podcasts.pdfImport.title": "Importer un document (PDF ou Markdown)",
  "podcasts.pdfImport.subtitle": "Créer les épisodes du podcast « {{podcast}} » à partir de la structure du document",
  "podcasts.pdfImport.hint": "Le document est découpé automatiquement : Titre 1 / # → épisode, Titre 2 / ## → chapitre, paragraphes → blocs. Les PDF sont d’abord convertis en Markdown pour relecture et validation. Formats : PDF ou .md.",
  "podcasts.pdfImport.convertingPdf": "Conversion du PDF en Markdown…",
  "podcasts.pdfImport.markdownReviewTitle": "Valider le Markdown généré",
  "podcasts.pdfImport.markdownReviewSubtitle": "Podcast « {{podcast}} » — Markdown généré depuis votre PDF. Relisez, corrigez les titres (# / ##) puis validez.",
  "podcasts.pdfImport.markdownReviewHint": "Vérifiez que chaque épisode commence par # et chaque chapitre par ##. Vous pouvez corriger le texte avant de continuer.",
  "podcasts.pdfImport.markdownEditorLabel": "Contenu Markdown",
  "podcasts.pdfImport.markdownEditorHint": "# Épisode · ## Chapitre · paragraphes = blocs de script",
  "podcasts.pdfImport.validateMarkdown": "Valider et voir la structure",
  "podcasts.pdfImport.editMarkdown": "Modifier le Markdown",
  "podcasts.pdfImport.markdownEmpty": "Le Markdown est vide.",
  "podcasts.pdfImport.dropLabel": "Déposez un PDF ou un fichier .md, ou choisissez un fichier",
  "podcasts.pdfImport.chooseFile": "Choisir un fichier",
  "podcasts.pdfImport.analyzing": "Analyse du document…",
  "podcasts.pdfImport.pageCount": "{{count}} page(s)",
  "podcasts.pdfImport.lineCount": "{{count}} ligne(s)",
  "podcasts.pdfImport.stats": "{{episodes}} épisode(s) · {{chapters}} chapitre(s) · {{blocks}} section(s)",
  "podcasts.pdfImport.episodeLabel": "Épisode {{index}} — {{title}}",
  "podcasts.pdfImport.sectionsCount": "{{count}} section(s)",
  "podcasts.pdfImport.confirm": "Créer les épisodes",
  "podcasts.pdfImport.importing": "Création en cours…",
  "podcasts.pdfImport.previewError": "Impossible d’analyser ce document.",
  "podcasts.pdfImport.importError": "Échec de l’import.",
  "podcasts.pdfImport.invalidFile": "Seuls les fichiers PDF et Markdown (.md) sont acceptés.",
  "podcasts.pdfImport.success": "{{episodes}} épisode(s), {{chapters}} chapitre(s) et {{blocks}} section(s) créés.",
  "podcasts.pdfImport.hintEditorPage": "Après sélection du fichier, vous serez redirigé vers l’éditeur Markdown avec un panneau d’aide à la structure (épisodes, chapitres, alertes).",
  "podcasts.pdfImport.editorPageTitle": "Préparer l’import du document",
  "podcasts.pdfImport.editorPageSubtitle": "Podcast « {{podcast}} » — {{file}}",
  "podcasts.pdfImport.editorEmptyHint": "Choisissez un PDF ou un fichier Markdown pour commencer. Vous pourrez corriger la structure avant de créer les épisodes.",
  "podcasts.pdfImport.backToPodcasts": "Retour aux podcasts",
  "podcasts.pdfImport.replaceFile": "Changer de fichier",
  "podcasts.pdfImport.documentTitleLabel": "Titre du document",
  "podcasts.pdfImport.untitledDocument": "Sans titre",
  "podcasts.pdfImport.invalidRoute": "Podcast introuvable.",
  "podcasts.pdfImport.fixErrorsBeforeImport": "Corrigez les erreurs de structure (panneau de droite) avant de créer les épisodes.",
  "podcasts.pdfImport.structurePanelTitle": "Aide à la conception",
  "podcasts.pdfImport.structurePanelSubtitle": "Estimation et alertes en temps réel pendant l’édition.",
  "podcasts.pdfImport.estimatedStructure": "Structure estimée",
  "podcasts.pdfImport.statEpisodes": "Épisodes",
  "podcasts.pdfImport.statChapters": "Chapitres",
  "podcasts.pdfImport.statBlocks": "Blocs",
  "podcasts.pdfImport.noPreviewYet": "Saisissez ou importez du contenu pour analyser la structure.",
  "podcasts.pdfImport.markdownMeta": "{{lines}} lignes · {{h1}} titre(s) # · {{h2}} titre(s) ##",
  "podcasts.pdfImport.structureBlocked": "Des erreurs bloquent l’import — corrigez le Markdown.",
  "podcasts.pdfImport.structureReady": "Structure exploitable — vous pouvez créer les épisodes.",
  "podcasts.pdfImport.structureIssues": "Alertes de structure",
  "podcasts.pdfImport.goToLine": "Aller à la ligne {{line}} dans l’éditeur",
  "podcasts.pdfImport.suggestions": "Suggestions",
  "podcasts.pdfImport.outlinePreview": "Aperçu de l’arborescence",
  "podcasts.pdfImport.conceptionGuide": "Guide de structuration",
  "podcasts.pdfImport.guideH1": "# Titre 1 = un épisode du podcast (ex. chapitre de livre, partie de cours).",
  "podcasts.pdfImport.guideH2": "## Titre 2 = chapitre à l’intérieur de l’épisode (sections, sous-parties).",
  "podcasts.pdfImport.guideBlocks": "Paragraphes et listes = blocs de narration lus à la voix.",
  "podcasts.pdfImport.guidePdf": "Chaque PDF est différent : relisez toujours le Markdown généré et ajustez les # / ## avant l’import.",
  "podcasts.episodeOrder.label": "Ordre des épisodes",
  "podcasts.episodeOrder.help": "Ordre de lecture dans le podcast (suit l’ordre du document à l’import).",
  "podcasts.episodeOrder.ariaGroup": "Ordre des épisodes",
  "podcasts.episodeOrder.newestFirst": "Plus récent → plus ancien",
  "podcasts.episodeOrder.oldestFirst": "Plus ancien → plus récent",
  "podcasts.list.filterAll": "Tous",
  "podcasts.list.filterArchived": "Archivés",
  "podcasts.list.archivePodcast": "Archiver le podcast",
  "podcasts.list.restoreFromArchive": "Restaurer depuis les archives",
  "podcasts.list.archiveSuccess": "Podcast archivé",
  "podcasts.list.archiveError": "Impossible d’archiver le podcast.",
  "podcasts.list.restoreSuccess": "Podcast restauré",
  "podcasts.list.restoreError": "Impossible de restaurer le podcast.",
  "podcasts.list.badgeArchived": "Archivé",
  "podcasts.list.emptyArchivedNone": "Aucun podcast archivé.",
  "podcasts.list.emptyAllArchived": "Tous les podcasts sont archivés. Ouvrez l’onglet « Archivés » pour les retrouver.",
  "podcasts.learner.pageTitle": "Écouter le podcast",
  "podcasts.learner.invalidLink": "Lien invalide ou expiré",
  "podcasts.learner.loadError": "Impossible de charger le podcast",
  "podcasts.learner.loading": "Chargement du podcast…",
  "podcasts.learner.noEpisodes": "Aucun épisode publié disponible.",
  "podcasts.learner.listen": "Écouter",
  "podcasts.learner.pause": "Pause",
  "podcasts.public": "Podcast",
  "podcasts.public.subscribeButton": "S’abonner aux nouveautés",
  "podcasts.public.subscribeModalTitle": "Recevoir les nouveaux épisodes par email",
  "podcasts.public.subscribeModalIntro": "Indiquez vos coordonnées. Nous vous enverrons un email lors de la publication d’un nouvel épisode.",
  "podcasts.public.fieldFirstName": "Prénom",
  "podcasts.public.fieldLastName": "Nom",
  "podcasts.public.fieldEmail": "Email",
  "podcasts.public.fieldCompany": "Société (facultatif)",
  "podcasts.public.submitSubscribe": "Valider l’abonnement",
  "podcasts.public.cancel": "Annuler",
  "podcasts.public.done": "Terminé",
  "podcasts.public.subscribeSuccess": "Merci ! Vous serez informé(e) à chaque nouvel épisode.",
  "podcasts.public.subscribeError": "Impossible de finaliser l’abonnement. Réessayez plus tard.",
  "podcasts.public.subscribeValidationRequired": "Le prénom, le nom et l’email sont obligatoires.",
  "podcasts.public.totalDuration": "{{duration}} au total",
  "podcasts.public.listenExcerpt": "Écouter l'extrait",
  "podcasts.playback.resumeAt": "Reprise à {{time}}",
  "podcasts.playback.listened": "Écouté",
  "podcasts.playback.listenedCount": "{{count}} écouté(s)",
  "podcasts.share.socialNetworksHeading": "Partager sur les réseaux",
  "podcasts.share.shareLinkedIn": "Partager sur LinkedIn",
  "podcasts.share.shareFacebook": "Partager sur Facebook",
  "podcasts.share.shareTwitter": "Partager sur X (Twitter)",
  "podcasts.share.publicShareStatsHeading": "Statistiques page publique",
  "podcasts.share.publicShareStatsVisits": "Visites (page publique)",
  "podcasts.share.publicShareStatsLoading": "Chargement des statistiques…",
  "podcasts.share.publicShareStatsUnavailable": "Statistiques indisponibles pour le moment.",
  "podcasts.share.publicShareStatsLinkedIn": "LinkedIn",
  "podcasts.share.publicShareStatsFacebook": "Facebook",
  "podcasts.share.publicShareStatsTwitter": "X (Twitter)",
  "podcasts.share.publicSubscribersHeading": "Abonnés (notifications email)",
  "podcasts.share.publicSubscribersEmpty": "Aucun abonné pour l’instant.",
  "podcasts.share.publicSubscribersCompany": "Entreprise",
  "share.publicQrTitle": "QR code du lien public",
  "share.publicQrError": "Impossible de générer le QR code.",
  "share.downloadQrPng": "Télécharger en PNG",
  "learningPaths.editor.backToList": "Retour aux parcours",
  "learningPaths.editor.pathNameLabel": "Nom du parcours *",
  "learningPaths.editor.idCopyHint": "Identifiant du parcours (pour le support)",
  "learningPaths.editor.sectionNavAria": "Sections de l’éditeur de parcours",
  "learningPaths.editor.tabContents": "Contenus",
  "learningPaths.editor.tabLearners": "Apprenants",
  "webinars.card.exportAttendance": "Télécharger la présence (CSV)",
  "webinars.card.attendanceExportError": "Impossible de télécharger le fichier de présence.",
  "webinars.card.publicSignupBadge": "Inscription publique",
  "webinars.panel.backgroundUrlLabel": "Adresse de l’image (URL)",
  "webinars.panel.backgroundUploadTitle": "Importer une image (Mes images)",
  "webinars.panel.backgroundLibraryTitle": "Mes images",
  "webinars.panel.backgroundLibraryEmpty": "Aucune image pour l’instant — importez ci-dessus ou depuis la page Images du tableau de bord.",
  "webinars.panel.backgroundOpenImagesPage": "Ouvrir la page Images",
  "webinars.panel.backgroundUseDefault": "Utiliser le fond Lyrra par défaut",
  "webinars.panel.backgroundUploading": "Envoi en cours…",
  "webinars.panel.backgroundUploadError": "Échec de l’envoi de l’image.",
  "webinars.panel.publicAccessTitle": "Inscription publique (formulaire)",
  "webinars.panel.publicAccessHelp": "Les participants non co-présentateurs remplissent un formulaire après connexion Lyrra : e-mail, mot de passe (qu’ils choisissent) et les champs supplémentaires que vous ajoutez ci-dessous.",
  "webinars.panel.publicFormFixedFieldsHint": "E-mail et mot de passe (8 caractères min.) sont toujours demandés aux participants ; vous ajoutez ici d’autres champs optionnels ou obligatoires.",
  "webinars.panel.publicFormAddFieldButton": "Ajouter un champ",
  "webinars.panel.publicFormFieldNumber": "Champ {{n}}",
  "webinars.panel.publicFormFieldLabel": "Libellé affiché",
  "webinars.panel.publicFormFieldType": "Type",
  "webinars.panel.publicFormFieldTypeText": "Texte court",
  "webinars.panel.publicFormFieldTypeTextarea": "Texte long",
  "webinars.panel.publicFormFieldRequired": "Obligatoire",
  "webinars.panel.publicFormFieldRemove": "Retirer",
  "webinars.panel.publicFormFieldIdHint": "Identifiant technique :",
  "webinars.panel.publicFormFieldLabelRequired": "Chaque champ doit avoir un libellé.",
  "webinars.panel.publicAccessLoginLabel": "Identifiant du formulaire d’inscription",
  "webinars.panel.publicAccessPasswordLabel": "Mot de passe du formulaire",
  "webinars.panel.publicAccessPasswordPlaceholderNew": "Au moins 8 caractères",
  "webinars.panel.publicAccessPasswordPlaceholderKeep": "Laisser vide pour conserver le mot de passe actuel",
  "webinars.panel.publicAccessPasswordHint": "À la création ou à la première activation : mot de passe obligatoire (8 caractères min.). Ensuite : laissez vide pour ne pas le changer.",
  "webinars.panel.publicAccessLoginRequired": "Indiquez un identifiant pour l’inscription publique.",
  "webinars.panel.publicAccessPasswordRequired": "Définissez un mot de passe d’au moins 8 caractères.",
  "webinars.panel.publicAccessPasswordMin": "Le mot de passe public doit contenir au moins 8 caractères.",
  "videos.card.draft": "Brouillon",
  "videos.page.studioButton": "Studio",
  "videos.studio.title": "Studio vidéo",
  "videos.studio.rail.prep": "Prépa",
  "videos.studio.rail.capture": "Capture",
  "videos.studio.rail.post": "Montage",
  "videos.studio.rail.aria": "Étapes du studio vidéo",
  "videos.studio.badge.setup": "Préparation",
  "videos.studio.badge.capture": "Capture",
  "videos.studio.badge.recording": "Enregistrement",
  "videos.studio.badge.post": "Montage",
  "videos.studio.cannotLeaveRecord": "Arrêtez l’enregistrement avant de changer d’étape.",
  "videos.studio.railNeedRecording": "Enregistrez une vidéo pour accéder au montage.",
  "videos.studio.sidebar.captureHelp": "La capture enregistre l’intégralité du flux partagé (écran, onglet ou fenêtre). Le rognage pour ne garder qu’une zone utile se fera à l’étape Montage.",
  "videos.studio.sidebar.sources": "Sources",
  "videos.studio.sidebar.recordingLive": "Enregistrement en cours",
  "videos.studio.sidebar.finalizeHint": "Pour enregistrer dans la bibliothèque, utilisez le bouton dans la barre supérieure.",
  "videos.studio.canvas.setupEmpty": "Consultez les indications dans le panneau latéral, puis passez à l’étape Capture.",
  "videos.studio.stepSetup": "Préparation",
  "videos.studio.stepCapture": "Capture",
  "videos.studio.stepPost": "Montage",
  "videos.studio.titleLabel": "Titre de la vidéo",
  "videos.studio.titlePlaceholder": "Ma capture…",
  "videos.studio.saveSetup": "Continuer vers la capture",
  "videos.studio.fieldDescription": "Description",
  "videos.studio.fieldCategories": "Catégories",
  "videos.studio.categoriesHint": "Une ou plusieurs catégories de votre établissement (optionnel).",
  "videos.studio.categoriesEmptyInstitution": "Aucune catégorie n’est configurée pour votre établissement.",
  "videos.studio.audioTrackPlanned": "Piste audio prévue",
  "videos.studio.voiceHumanPlan": "Voix humaine (micro enregistré)",
  "videos.studio.voiceAiPlan": "Voix IA (choix pour le montage)",
  "videos.studio.postVoiceHumanKeep": "Vous avez choisi la voix humaine : la vidéo conserve l’audio du micro. Passez à la finalisation lorsque vous êtes prêt.",
  "videos.studio.titleUntitled": "Sans titre",
  "videos.studio.voiceAiNoVoices": "Aucune voix IA disponible pour le moment.",
  "videos.studio.postVoiceAiPipeline": "Voix IA : préparez le texte, générez la piste audio puis appliquez-la à la vidéo.",
  "videos.studio.allowMedia": "Autoriser écran et microphone",
  "videos.studio.controlsHint": "Astuce : pour éviter d’enregistrer cette barre, partagez un onglet ou une fenêtre plutôt que tout l’écran, ou utilisez un second écran. Espace = pause / reprise lorsque cette page a le focus.",
  "videos.studio.warnTabOnly": "Vous avez sélectionné un seul onglet : seul cet onglet sera enregistré, même si vous en ouvrez d’autres. Pour capturer plusieurs onglets ou fenêtres, relancez la capture et choisissez « Écran entier ».",
  "videos.studio.templateMenuTitle": "Menu des modèles",
  "videos.studio.templateEmpty": "Aucun modèle enregistré",
  "videos.studio.templatesHintCompact": "Cliquez sur + pour enregistrer, appliquer ou supprimer un modèle.",
  "videos.studio.overlayAddMusic": "Musique de fond",
  "videos.studio.musicInvalidType": "Format invalide. Utilisez un audio (MP3, WAV, M4A, OGG).",
  "videos.studio.musicTooLarge": "Le fichier audio ne doit pas dépasser 50 Mo.",
  "videos.studio.musicDefault": "Musique",
  "videos.studio.musicAdded": "Musique de fond ajoutée à la timeline.",
  "videos.studio.musicUploadError": "Impossible d'ajouter la musique.",
  "videos.studio.layerScreenBorder": "Bordure extérieure",
  "videos.studio.layerScreenBorderSize": "Taille",
  "videos.studio.layerScreenBorderColor": "Couleur",
  "videos.studio.layerScreenBorderRadius": "Arrondi des angles",
  "videos.studio.segmentToolsTitle": "Outils de section",
  "videos.studio.segmentZoom": "Zoom",
  "videos.studio.segmentResetView": "Réinit. vue",
  "videos.studio.segmentTransition": "Transition",
  "videos.studio.transitionNone": "Aucune",
  "videos.studio.transitionFade": "Fondu",
  "videos.studio.transitionWipeLeft": "Balayage →",
  "videos.studio.transitionSlideUp": "Glissé ↑",
  "videos.studio.textEditor.toolbar": "Mise en forme",
  "videos.studio.textEditor.bold": "Gras",
  "videos.studio.textEditor.italic": "Italique",
  "videos.studio.textEditor.underline": "Souligné",
  "videos.studio.textEditor.textColor": "Couleur du texte (sélection)",
  "videos.studio.textEditor.size": "Taille",
  "videos.studio.textEditor.font": "Police",
  "videos.studio.textEditor.fontFamily.system": "Système",
  "videos.studio.textEditor.fontFamily.sansInter": "Sans (Inter)",
  "videos.studio.textEditor.fontFamily.serif": "Serif",
  "videos.studio.textEditor.fontFamily.mono": "Mono",
  "videos.studio.textEditor.fontFamily.script": "Script",
  "videos.studio.controlsHintTab": "Vous partagez un autre onglet : la vidéo ne montre pas cette page Studio (les boutons n’y figurent donc pas). Gardez le Studio dans une autre fenêtre du navigateur ou sur un second écran, à côté de votre contenu. Pour Pause, Arrêter ou Terminer, basculez vers la fenêtre où est ouvert le Studio (Alt+Tab ou Cmd+Tab). La touche Espace ne fonctionne que lorsque le focus est sur la page Studio.",
  "videos.studio.controlsHintMonitor": "Vous partagez tout l’écran : cette barre peut apparaître dans l’enregistrement. Pour l’éviter, choisissez plutôt « Onglet » ou « Fenêtre » dans le partage, ou placez les contrôles sur un autre moniteur.",
  "videos.studio.controlsHintWindow": "Vous partagez une fenêtre : le reste du bureau (et les autres fenêtres) n’est en principe pas enregistré. Utilisez les boutons ci-dessous pour Pause, Arrêt ou Terminer.",
  "videos.studio.startRecord": "Enregistrer",
  "videos.studio.pause": "Pause",
  "videos.studio.resume": "Reprendre",
  "videos.studio.stop": "Arrêter",
  "videos.studio.terminer": "Terminer",
  "videos.studio.processingUpload": "Envoi et transcription…",
  "videos.studio.timeline": "Lecture",
  "videos.studio.transcript": "Texte reconnu",
  "videos.studio.transcriptRefining": "Amélioration de la transcription en cours…",
  "videos.studio.transcriptPlaceholder": "Le texte reconnu depuis votre enregistrement apparaîtra ici…",
  "videos.studio.voiceMode": "Piste audio",
  "videos.studio.voiceOriginal": "Ma voix (micro enregistré)",
  "videos.studio.voiceAi": "Voix IA (Mistral TTS)",
  "videos.studio.voiceSelect": "Voix",
  "videos.studio.polish": "Préparer le texte pour la voix IA",
  "videos.studio.generateTts": "Générer la voix off",
  "videos.studio.applyVoiceover": "Appliquer la voix IA à la vidéo",
  "videos.studio.preview": "Prévisualiser",
  "videos.studio.preview.noFile": "Aucun fichier vidéo à prévisualiser.",
  "videos.studio.bgImage": "Image de fond",
  "videos.studio.bgImageChoose": "Choisir",
  "videos.studio.bgImageInvalidType": "Format invalide. Utilisez une image (PNG, JPG, WebP).",
  "videos.studio.bgImageTooLarge": "L'image ne doit pas dépasser 10 Mo.",
  "videos.studio.bgImageLoadError": "Impossible de charger l’image de fond.",
  "videos.studio.bgImageUploading": "Envoi…",
  "videos.studio.bgImageUploadError": "Impossible d'envoyer l'image. Réessayez.",
  "videos.studio.bgImageLibraryTitle": "Fond studio vidéo",
  "videos.studio.postLayoutTitle": "Cadre & fond",
  "videos.studio.postLayoutHint": "Aperçu aligné sur la vidéo publiée : enregistrez le brouillon puis publiez pour appliquer fond, taille et position.",
  "videos.studio.bgImageVideoSize": "Taille vidéo",
  "videos.studio.dragToMove": "Glisser pour déplacer",
  "videos.studio.finalize": "Finaliser et enregistrer",
  "videos.studio.saveDraft": "Brouillon",
  "videos.studio.publish": "Publier",
  "videos.studio.successDraft": "Vidéo enregistrée en brouillon",
  "videos.studio.successPublish": "Vidéo publiée dans votre bibliothèque",
  "videos.studio.processingPublish": "Traitement de la vidéo en cours…",
  "videos.studio.back": "Retour aux vidéos",
  "videos.studio.errorMedia": "Impossible d’accéder à l’écran ou au micro.",
  "videos.studio.errorInsecureContext": "La capture nécessite HTTPS ou localhost. Ouvrez l’application via https:// ou http://127.0.0.1 / localhost.",
  "videos.studio.errorNotSupported": "Ce navigateur ou appareil ne prend pas en charge la capture d’écran ici. Utilisez Chrome ou Edge à jour sur ordinateur.",
  "videos.studio.errorMicDenied": "Micro refusé : autorisez le micro pour ce site (icône cadenas ou ⓘ dans la barre d’adresse), puis réessayez.",
  "videos.studio.errorScreenDenied": "Partage d’écran refusé : dans la fenêtre du navigateur, choisissez un écran ou un onglet et validez « Partager ».",
  "videos.studio.errorMicMissing": "Aucun micro détecté. Vérifiez le branchement et les réglages système.",
  "videos.studio.errorScreenMissing": "Partage d’écran indisponible sur cet appareil ou ce navigateur.",
  "videos.studio.errorMicBusy": "Micro déjà utilisé par une autre application. Fermez-la puis réessayez.",
  "videos.studio.errorScreenBusy": "Capture d’écran impossible (ressource occupée). Réessayez ou redémarrez le navigateur.",
  "videos.studio.errorScreenCancelled": "Partage d’écran annulé.",
  "videos.studio.errorMicCancelled": "Accès au micro annulé.",
  "videos.studio.errorMicGeneric": "Impossible d’accéder au micro.",
  "videos.studio.errorScreenGeneric": "Impossible de capturer l’écran.",
  "videos.studio.errorScreenEnded": "Partage d’écran arrêté.",
  "videos.studio.mediaHints": "Chrome ou Edge sur ordinateur. Si l’URL est en http:// avec une IP type 192.168.x.x, le navigateur bloque souvent la capture : utilisez http://localhost:5173 ou un HTTPS valide.",
  "videos.studio.errorRecord": "Enregistrement impossible sur ce navigateur.",
  "videos.studio.errorUpload": "Échec de l’envoi.",
  "videos.studio.errorLoadDraft": "Impossible de charger le brouillon.",
  "videos.studio.errorTranscribe": "Transcription indisponible.",
  "videos.studio.errorPolish": "Reformulation IA impossible.",
  "videos.studio.errorTts": "Synthèse vocale impossible.",
  "videos.studio.errorMux": "Montage audio impossible.",
  "videos.studio.muxSuccess": "Voix IA appliquée à la vidéo",
  "videos.studio.successFinal": "Vidéo enregistrée dans votre bibliothèque",
  "videos.studio.generatingTimeline": "Génération de la timeline…",
  "videos.studio.crop": "Recadrer",
  "videos.studio.cropReset": "Réinitialiser le recadrage",
  "videos.studio.cropActive": "Recadrage actif — déplacez ou redimensionnez la zone sur la vidéo",
  "videos.studio.cropDone": "Terminer",
  "videos.studio.cropApplied": "Rognage appliqué",
  "videos.studio.cropEdit": "Modifier",
  "videos.studio.cropRemove": "Supprimer",
  "videos.studio.trimIn": "IN",
  "videos.studio.trimOut": "OUT",
  "videos.studio.trimDuration": "durée",
  "sounds.card.download": "Télécharger",
  "pages.images.copyUrlSuccess": "URL copiée dans le presse-papiers.",
  "pages.images.copyUrlError": "Impossible de copier l’URL.",
  "pages.images.urlLabel": "URL publique",
  "pages.images.download": "Télécharger",
  "pages.images.downloadSuccess": "Téléchargement lancé.",
  "pages.images.downloadError": "Téléchargement impossible.",
  "pages.images.viewGrid": "Grille",
  "pages.images.viewList": "Liste",
  "pages.images.editPanelTitle": "Modifier l’image",
  "pages.images.editPanelSubtitle": "Titre, description et nom de fichier. Remplacer le fichier conserve la même URL (les contenus qui l’utilisent restent valides).",
  "pages.images.replaceFileLabel": "Nouvelle image",
  "pages.images.replaceFileHint": "Le format est adapté à l’extension actuelle du fichier. L’URL publique ne change pas.",
  "pages.images.fileOriginalNameLabel": "Nom du fichier d’origine",
  "pages.images.saveChanges": "Enregistrer",
  "pages.images.saveSuccess": "Image mise à jour.",
  "pages.images.saveError": "Enregistrement impossible.",
  "pages.images.editAction": "Modifier",
  "accessibility.simplifiedTextPageLoading": "Simplification du contenu de cette page par IA…",
  "accessibility.simplifiedTextPageError": "Impossible de simplifier le contenu de cette page pour le moment. Réessayez dans un instant.",
  "accessibility.imageHoverAudio.loading": "Chargement de la description audio…",
  "accessibility.imageHoverAudio.loadingTts": "Génération de la description audio…",
  "accessibility.imageHoverAudio.loadingVision": "Analyse de l’image et génération audio…",
  "accessibility.imageHoverAudio.playing": "Lecture de la description…",
  "accessibility.imageHoverAudio.error": "Lecture audio impossible.",
  "accessibility.imageHoverAudio.unavailable": "Description audio indisponible pour cette image.",
  "admin.dashboard.activeToday": "Actifs aujourd’hui",
  "admin.dashboard.quickActions": "Actions rapides",
  "admin.header.workspace": "Administration plateforme",
  "admin.institutionDetail.pageTitle": "Établissement — Administration",
  "admin.institutionDetail.backToList": "Retour aux établissements",
  "pages.branding.title": "Identité visuelle",
  "pages.budget.comingSoonDesc": "Planifiez et suivez votre budget de formation, gérez les enveloppes et les dépenses par département.",
  "pages.budget.description": "Gestion du budget de formation",
  "player.manualVoiceoverMic": "Enregistrer la voix off pour cette langue",
  "player.manualVoiceoverStudioTitle": "Studio d\\u2019enregistrement voix off",
  "player.manualVoiceoverStudioLang": "Langue de l\\u2019enregistrement",
  "player.manualVoiceoverRecord": "Enregistrer",
  "player.manualVoiceoverStop": "Arrêter",
  "player.manualVoiceoverPlay": "Écouter",
  "player.manualVoiceoverSave": "Enregistrer sur le bloc",
  "player.manualVoiceoverClose": "Fermer",
  "player.manualVoiceoverHint": "À droite : le texte ou l\\u2019image du bloc dans la langue choisie. Enregistrez, puis enregistrez sur le bloc pour associer l\\u2019audio à cette langue.",
  "player.manualVoiceoverPreviewLoading": "Chargement du contenu…",
  "player.manualVoiceoverNoMic": "Micro ou enregistrement indisponible dans ce navigateur.",
  "player.manualVoiceoverNoText": "Aucun texte de description suffisant pour ce bloc.",
  "player.manualVoiceoverSaveError": "Impossible d\\u2019enregistrer la voix sur le bloc.",
  "player.manualVoiceoverUploadError": "Échec du téléversement audio.",
  "player.manualVoiceoverSaved": "Voix off enregistrée sur le bloc.",
  "rh.auditDateUnknown": "Non renseigné",
  "rh.auditScheduleHint": "À définir dans les paramètres établissement",
  "rh.compliance": "Conformité",
  "rh.complianceAuditAction.qualiopi_corrective_action_create": "Création d'une action corrective Qualiopi",
  "rh.complianceAuditAction.qualiopi_corrective_action_delete": "Suppression d'une action corrective Qualiopi",
  "rh.complianceAuditAction.qualiopi_corrective_action_update": "Mise à jour d'une action corrective Qualiopi",
  "rh.complianceAuditAction.qualiopi_evidence_create": "Ajout d'une preuve Qualiopi",
  "rh.complianceAuditAction.qualiopi_indicator_update": "Mise à jour d'un indicateur Qualiopi",
  "rh.complianceAuditAction.compliance_regulatory_watch_create": "Création d'un élément de veille réglementaire",
  "rh.complianceAuditAction.compliance_regulatory_watch_update": "Mise à jour d'un élément de veille réglementaire",
  "rh.complianceAuditAction.compliance_regulatory_watch_delete": "Suppression d'un élément de veille réglementaire",
  "rh.compliancePage.tabs.difficulty": "Difficultés",
  "rh.compliancePage.tabs.handicap": "Référent handicap",
  "rh.compliancePage.tabs.learnerBilan": "Bilan apprenants",
  "rh.compliancePage.tabs.regulatory": "Veille réglementaire",
  "rh.regulatoryWatch.lyrraBadge": "LyrraOne",
  "rh.regulatoryWatch.ofResponse": "Notre réponse / positionnement",
  "rh.regulatoryWatch.ofResponsePlaceholder": "Ce que nous avons fait ou prévu…",
  "rh.regulatoryWatch.ackStatus": "Statut",
  "rh.regulatoryWatch.ack.pending": "À traiter",
  "rh.regulatoryWatch.ack.read": "Pris en compte (lu)",
  "rh.regulatoryWatch.ack.actionTaken": "Action menée",
  "rh.regulatoryWatch.ack.notApplicable": "Non applicable",
  "rh.regulatoryWatch.pdf.title": "Registre de veille réglementaire",
  "rh.regulatoryWatch.pdf.subtitleFallback": "Établissement",
  "rh.regulatoryWatch.pdf.generatedAt": "Document généré le {{date}}",
  "rh.regulatoryWatch.pdf.colDate": "Date",
  "rh.regulatoryWatch.pdf.colCategory": "Cat.",
  "rh.regulatoryWatch.pdf.colTitle": "Titre",
  "rh.regulatoryWatch.pdf.colDesc": "Description (extrait)",
  "rh.regulatoryWatch.pdf.colImpact": "Impact",
  "rh.regulatoryWatch.pdf.colOrigin": "Origine",
  "rh.regulatoryWatch.pdf.colStatus": "Statut",
  "rh.regulatoryWatch.pdf.colAction": "Action",
  "rh.regulatoryWatch.pdf.colWho": "Utilisateur",
  "rh.regulatoryWatch.pdf.colWhen": "Horodatage",
  "rh.regulatoryWatch.pdf.originLyrra": "LyrraOne",
  "rh.regulatoryWatch.pdf.originOf": "OF",
  "rh.regulatoryWatch.pdf.readYes": "Lu",
  "rh.regulatoryWatch.pdf.readNo": "Non lu",
  "rh.regulatoryWatch.pdf.actionDone": "Action faite",
  "rh.regulatoryWatch.pdf.actionOpen": "Action en cours",
  "rh.regulatoryWatch.pdf.emptyWatch": "Aucun élément enregistré",
  "rh.regulatoryWatch.pdf.auditSection": "Journal interne (traçabilité)",
  "rh.regulatoryWatch.pdf.auditHint": "Actions enregistrées automatiquement dans la plateforme.",
  "rh.regulatoryWatch.pdf.emptyAudit": "Aucun événement récent",
  "rh.regulatoryWatch.exportPdf": "Exporter PDF",
  "rh.regulatoryWatch.exportPdfBusy": "Export PDF…",
  "rh.regulatoryWatch.exportPdfError": "Export PDF impossible",
  "rh.compliancePage.tabs.satisfaction": "Satisfaction",
  "rh.qualiopiEmpty": "Aucune donnée Qualiopi disponible pour cet établissement.",
  "rh.qualiopiLoading": "Chargement du référentiel Qualiopi…",
  "v2.compliance": "Conformité & Qualiopi",
  "designer.validation.formFieldRefsMissing": "« {{title}} » : référence(s) vers champ(s) de formulaire inexistants : {{refs}}.",
  "designer.validation.formFieldRefsOrder": "« {{title}} » : variable(s) de formulaire incorrecte(s) {{refs}} — le bloc formulaire doit être atteint avant ce bloc dans le parcours.",
  "designer.confirmDeleteForm.title": "Supprimer ce bloc formulaire ?",
  "designer.confirmDeleteForm.message": "D’autres blocs peuvent utiliser ses champs sous la forme /identifiant/. Ces références deviendront invalides. Vous pouvez annuler avec ⌘Z ou Ctrl+Z.",
  "designer.confirmDeleteForm.batchTitle": "Supprimer la sélection ?",
  "designer.confirmDeleteForm.batchMessage": "La sélection contient au moins un bloc formulaire. Des références /identifiant/ ailleurs dans le parcours peuvent devenir invalides. Vous pouvez annuler avec ⌘Z ou Ctrl+Z.",
  "voicePanel.multiLangHint": "Pour une voix Mistral par langue (les 12 langues de l’interface), ouvrez le panneau Traduction (icône langues dans la barre du designer).",
  "episodeEditor.block.source": "Source",
  "episodeEditor.block.sourceTts": "IA",
  "episodeEditor.block.sourceMic": "Micro",
  "episodeEditor.block.pauseBefore": "Pause avant",
  "episodeEditor.block.pauseBeforeHint": "Silence avant de lire ce bloc (la suite).",
  "episodeEditor.block.pause0": "0 s",
  "episodeEditor.block.pause05": "0,5 s",
  "episodeEditor.block.pause1": "1 s",
  "episodeEditor.block.record": "Enregistrer",
  "episodeEditor.block.stopRecording": "Arrêter",
  "episodeEditor.block.microMode": "Mode micro pour ce bloc",
  "episodeEditor.block.notesRecordingPlaceholder": "Notes optionnelles (non lues automatiquement en micro)",
  "episodeEditor.block.removeRecording": "Supprimer audio",
  "episodeEditor.edit.audioMixedHumanAndAi": "Piste IA + voix micro",
  "episodeEditor.errors.addTextOrRecording": "Ajoutez du texte (synthèse IA) ou enregistrez votre voix sur au moins un bloc avant de générer l'audio.",
  "episodeEditor.errors.saveDraftBeforeRecording": "Impossible de créer l’épisode pour le micro. Ajoutez un titre ou enregistrez depuis un épisode existant.",
  "episodeEditor.errors.microNotSupported": "Micro non disponible dans ce navigateur.",
  "episodeEditor.errors.microPermission": "Impossible d’accéder au micro (permission refusée).",
  "episodeEditor.errors.recordingUploadFailed": "Échec de l’upload de l’enregistrement.",
  "eduflow.designer.toast.flowPastedFromClipboard": "Parcours créé à partir du presse-papiers",
  "eduflow.designer.toast.exportFailed": "Export impossible.",
  "eduflow.designer.toast.importPackageFailed": "Import du package .lyrra impossible.",
  "eduflow.designer.loopHandle.loop": "Boucle",
  "eduflow.designer.loopHandle.end": "Fin",
  "a11y.skipToPlayerMain": "Aller au contenu de la formation",
  "a11y.playerMainLandmark": "Contenu de la formation",
  "a11y.dialog": "Dialogue",
  "a11y.closeDialog": "Fermer la boîte de dialogue",
  "a11y.dismissNotification": "Fermer la notification",
  "a11y.notificationsRegion": "Notifications",
  "a11y.skipLinksLandmark": "Liens d’accès rapide",
  "eduflow.blockEditor.audio.estimatedSeconds": "~{{sec}}s estimé",
  "eduflow.blockEditor.audio.fileLabel": "Fichier audio",
  "eduflow.blockEditor.audio.formatsHint": "MP3, WAV, OGG",
  "eduflow.blockEditor.audio.generateButton": "Générer l’audio",
  "eduflow.blockEditor.audio.generateTts": "Générer TTS",
  "eduflow.blockEditor.audio.import": "Importer",
  "eduflow.blockEditor.audio.langDe": "Deutsch",
  "eduflow.blockEditor.audio.langEn": "English",
  "eduflow.blockEditor.audio.langEs": "Español",
  "eduflow.blockEditor.audio.langFr": "Français",
  "eduflow.blockEditor.audio.langIt": "Italiano",
  "eduflow.blockEditor.audio.language": "Langue",
  "eduflow.blockEditor.audio.mistralVoice": "Voix (Mistral TTS)",
  "eduflow.blockEditor.audio.mistralVoicePlaceholder": "ID voix Mistral (console Mistral / API)",
  "eduflow.blockEditor.audio.voicesLoading": "Chargement des voix…",
  "eduflow.blockEditor.audio.voicesLoadError": "Impossible de charger les voix Mistral.",
  "eduflow.blockEditor.audio.voicesEmptyHint": "Aucune voix renvoyée par l’API. Vérifiez la clé Mistral (Administration → Intégrations). La synthèse utilise tout de même une voix par défaut.",
  "eduflow.blockEditor.audio.voiceFallbackOption": "{{id}} (défaut)",
  "eduflow.blockEditor.audio.generating": "Génération…",
  "eduflow.blockEditor.audio.generateNeedText": "Saisissez d’abord le texte à synthétiser.",
  "eduflow.blockEditor.audio.generateBadResponse": "Réponse TTS invalide.",
  "eduflow.blockEditor.audio.generateSuccess": "Audio généré.",
  "eduflow.blockEditor.audio.generateError": "Synthèse impossible (Mistral TTS / intégrations).",
  "eduflow.blockEditor.audio.preview": "Prévisualisation",
  "eduflow.blockEditor.audio.source": "Source audio",
  "eduflow.blockEditor.audio.speedLabel": "Vitesse : {{speed}}x",
  "eduflow.blockEditor.audio.syncWithText": "Synchroniser avec le texte (sous-titres)",
  "eduflow.blockEditor.audio.syncWithTextHelp": "Dans le lecteur : une zone sous la forme d’onde affiche le texte par segments, calés sur la position de lecture (répartition estimée sur la durée du fichier, pas de fichier VTT).",
  "eduflow.blockEditor.audio.ttsPlaceholder": "Saisissez le texte qui sera lu par la voix de synthèse…",
  "eduflow.blockEditor.audio.ttsText": "Texte à synthétiser",
  "eduflow.blockEditor.audio.urlLabel": "Ou URL du fichier audio",
  "eduflow.blockEditor.audio.urlPlaceholder": "https://example.com/audio.mp3",
  "eduflow.blockEditor.browser.allowExternalAria": "Autoriser d'autres sites web",
  "eduflow.blockEditor.browser.allowExternalHelp": "{{off}} : iframe protégée (sandbox) — limite popups et comportements sortants. {{on}} : meilleure compatibilité avec des pages riches (vidéos, widgets) ; navigation possible dans le cadre.",
  "eduflow.blockEditor.browser.allowExternalOff": "Désactivé",
  "eduflow.blockEditor.browser.allowExternalOn": "Activé",
  "eduflow.blockEditor.browser.allowExternalTitle": "Autoriser d’autres sites web",
  "eduflow.blockEditor.browser.frameTitleFallback": "Page web intégrée",
  "eduflow.blockEditor.browser.fullscreen": "Plein écran",
  "eduflow.blockEditor.browser.fullscreenTitle": "Aperçu — Page web intégrée",
  "eduflow.blockEditor.browser.openTab": "Ouvrir dans un onglet",
  "eduflow.blockEditor.browser.preview": "Aperçu",
  "eduflow.blockEditor.browser.urlHelp": "Saisissez l’adresse complète (https). L’aperçu est encadré par un décor de fenêtre — ce n’est pas un navigateur : l’apprenant ne modifie pas l’URL depuis cette interface.",
  "eduflow.blockEditor.browser.urlLabel": "URL de la page",
  "eduflow.blockEditor.browser.urlPlaceholder": "https://…",
  "eduflow.blockEditor.chart.addLabel": "Label",
  "eduflow.blockEditor.chart.addSeries": "Série",
  "eduflow.blockEditor.chart.animation": "Animation",
  "eduflow.blockEditor.chart.chartTitle": "Titre du graphique",
  "eduflow.blockEditor.chart.chartType": "Type de graphique",
  "eduflow.blockEditor.chart.colorTitle": "Couleur",
  "eduflow.blockEditor.chart.datasets": "Séries de données ({{count}})",
  "eduflow.blockEditor.chart.defaultLabel": "Label {{n}}",
  "eduflow.blockEditor.chart.defaultSeries": "Série {{n}}",
  "eduflow.blockEditor.chart.interactive": "Interactif (infobulles)",
  "eduflow.blockEditor.chart.labelsX": "Labels (axe X)",
  "eduflow.blockEditor.chart.noSeries": "Aucune série. Cliquez sur « Série » pour ajouter.",
  "eduflow.blockEditor.chart.readerPreviewHint": "Aperçu disponible en mode lecteur",
  "eduflow.blockEditor.chart.seriesNamePlaceholder": "Nom de la série",
  "eduflow.blockEditor.chart.settings": "Paramètres",
  "eduflow.blockEditor.chart.showGrid": "Afficher la grille",
  "eduflow.blockEditor.chart.showLegend": "Afficher la légende",
  "eduflow.blockEditor.chart.titlePlaceholder": "Titre optionnel",
  "eduflow.blockEditor.chart.typeArea": "Aire",
  "eduflow.blockEditor.chart.typeBar": "Barres",
  "eduflow.blockEditor.chart.typeDoughnut": "Anneau",
  "eduflow.blockEditor.chart.typeLine": "Ligne",
  "eduflow.blockEditor.chart.typePie": "Camembert",
  "eduflow.blockEditor.chart.typeRadar": "Radar",
  "eduflow.blockEditor.timer.sectionTitle": "Minuteur",
  "eduflow.blockEditor.timer.enable": "Activer le minuteur (lecteur)",
  "eduflow.blockEditor.timer.modeLabel": "Mode",
  "eduflow.blockEditor.timer.modeCountup": "Minuteur (0 → limite)",
  "eduflow.blockEditor.timer.countupHint": "Les 10 dernières secondes avant la limite passent en rouge.",
  "eduflow.blockEditor.timer.modeCountdown": "Décompte (limite → 0)",
  "eduflow.blockEditor.timer.countdownHint": "Les 5 dernières secondes passent en rouge.",
  "eduflow.blockEditor.timer.maxSecondsLabel": "Temps maximum (secondes)",
  "eduflow.blockEditor.evaluation.aiQuestions": "Générer des questions IA",
  "eduflow.blockEditor.evaluation.editFullscreen": "Éditer le formulaire (plein écran)",
  "eduflow.blockEditor.evaluation.hint": "Ouvrez l’éditeur plein écran pour composer le formulaire : glissez les types de champs depuis la colonne de gauche et réordonnez les questions par la poignée.",
  "eduflow.blockEditor.evaluation.metaLine": "{{qPart}} · {{pPart}} au total",
  "eduflow.blockEditor.evaluation.pointPlural": "points",
  "eduflow.blockEditor.evaluation.pointSingular": "point",
  "eduflow.blockEditor.evaluation.questionPlural": "questions",
  "eduflow.blockEditor.evaluation.questionSingular": "question",
  "eduflow.blockEditor.evaluation.title": "Formulaire d’évaluation",
  "eduflow.blockEditor.evaluationForm.addFreeText": "Ajouter texte libre",
  "eduflow.blockEditor.evaluationForm.addOption": "Option",
  "eduflow.blockEditor.evaluationForm.close": "Fermer",
  "eduflow.blockEditor.evaluationForm.delete": "Supprimer",
  "eduflow.blockEditor.evaluationForm.dropEmptyHint": "Déposez ici un type de question depuis le panneau de gauche, ou utilisez le bouton « Ajouter ».",
  "eduflow.blockEditor.evaluationForm.escapeHint": "Échap pour fermer",
  "eduflow.blockEditor.evaluationForm.expectedValue": "Valeur attendue",
  "eduflow.blockEditor.evaluationForm.footerStats": "{{n}} question(s) · {{pts}} pts au total",
  "eduflow.blockEditor.evaluationForm.headerSubtitle": "Glissez un type de question depuis la gauche vers la zone centrale. Réordonnez par la poignée ⋮⋮.",
  "eduflow.blockEditor.evaluationForm.headerTitle": "Éditeur de formulaire d’évaluation",
  "eduflow.blockEditor.evaluationForm.maxAttempts": "Tentatives max",
  "eduflow.blockEditor.evaluationForm.moveQuestion": "Déplacer la question",
  "eduflow.blockEditor.evaluationForm.optionPlaceholder": "Option…",
  "eduflow.blockEditor.evaluationForm.optionsHint": "Cliquez sur le pictogramme pour marquer la ou les bonnes réponses.",
  "eduflow.blockEditor.evaluationForm.overlayUntitled": "(sans titre)",
  "eduflow.blockEditor.evaluationForm.paletteSubtitle": "Déposez dans le canevas pour ajouter une question.",
  "eduflow.blockEditor.evaluationForm.paletteTitle": "Champs",
  "eduflow.blockEditor.evaluationForm.passThreshold": "Seuil de réussite : {{pct}}%",
  "eduflow.blockEditor.evaluationForm.pointsShort": "pts",
  "eduflow.blockEditor.evaluationForm.qTypeDropdown": "Liste déroulante",
  "eduflow.blockEditor.evaluationForm.qTypeFile": "Fichier",
  "eduflow.blockEditor.evaluationForm.qTypeMultiple": "Choix multiple",
  "eduflow.blockEditor.evaluationForm.qTypeNumeric": "Numérique",
  "eduflow.blockEditor.evaluationForm.qTypeSingle": "Choix unique",
  "eduflow.blockEditor.evaluationForm.qTypeText": "Texte libre",
  "eduflow.blockEditor.evaluationForm.questionTitlePlaceholder": "Intitulé de la question…",
  "eduflow.blockEditor.evaluationForm.refAnswerLabel": "Réponse de référence (optionnelle)",
  "eduflow.blockEditor.evaluationForm.refAnswerPlaceholder": "Réponse attendue…",
  "eduflow.blockEditor.evaluationForm.refEmptyHint": "Sans référence : toute réponse non vide est acceptée.",
  "eduflow.blockEditor.evaluationForm.required": "Oblig.",
  "eduflow.blockEditor.evaluationForm.semanticGrading": "Notation IA (similarité sémantique)",
  "eduflow.blockEditor.evaluationForm.semanticThreshold": "Seuil sémantique : {{pct}}%",
  "eduflow.blockEditor.evaluationForm.showCorrect": "Afficher les bonnes réponses",
  "eduflow.blockEditor.evaluationForm.showResults": "Afficher les résultats",
  "eduflow.blockEditor.evaluationForm.timeLimit": "Limite de temps",
  "eduflow.blockEditor.evaluationForm.tolerance": "Tolérance ±",
  "eduflow.blockEditor.glossary.add": "Ajouter",
  "eduflow.blockEditor.glossary.categories": "Catégories",
  "eduflow.blockEditor.glossary.definitionPlaceholder": "Définition",
  "eduflow.blockEditor.glossary.description": "Description",
  "eduflow.blockEditor.glossary.descriptionPlaceholder": "Aide de lecture du vocabulaire...",
  "eduflow.blockEditor.glossary.enableQuiz": "Activer le quiz intégré",
  "eduflow.blockEditor.glossary.includeInQuiz": "Inclure dans le quiz",
  "eduflow.blockEditor.glossary.newCategoryPlaceholder": "Nouvelle catégorie",
  "eduflow.blockEditor.glossary.noCategory": "Sans catégorie",
  "eduflow.blockEditor.glossary.panelHint": "Définissez vos termes et activez le mode quiz pour la révision.",
  "eduflow.blockEditor.glossary.panelTitle": "Glossaire + Quiz intégré",
  "eduflow.blockEditor.glossary.termPlaceholder": "Terme",
  "eduflow.blockEditor.glossary.termSingular": "Terme",
  "eduflow.blockEditor.glossary.termsCount": "Termes ({{count}})",
  "eduflow.blockEditor.glossary.titleLabel": "Titre du glossaire",
  "eduflow.blockEditor.glossary.titlePlaceholder": "Glossaire",
  "eduflow.blockEditor.htmlSource.formatButton": "Reformater",
  "eduflow.blockEditor.htmlSource.formatTitle": "Réindenter et structurer le HTML (même logique qu’à l’entrée en mode code)",
  "eduflow.blockEditor.htmlSource.findVerb": "rechercher",
  "eduflow.blockEditor.htmlSource.indentVerb": "indente",
  "eduflow.blockEditor.htmlSource.modeLabel": "Mode code HTML",
  "eduflow.blockEditor.mindmap.addChild": "Sous-nœud",
  "eduflow.blockEditor.mindmap.addMainBranch": "Ajouter une branche principale",
  "eduflow.blockEditor.mindmap.branchTitle": "Branche · {{title}}",
  "eduflow.blockEditor.mindmap.centralTheme": "Thème central",
  "eduflow.blockEditor.mindmap.close": "Fermer",
  "eduflow.blockEditor.mindmap.configureFullscreen": "Configurer en plein écran",
  "eduflow.blockEditor.mindmap.descriptionLabel": "Description",
  "eduflow.blockEditor.mindmap.descriptionPlaceholder": "Texte d’approfondissement",
  "eduflow.blockEditor.mindmap.dialogTitle": "Carte heuristique",
  "eduflow.blockEditor.mindmap.optional": "Optionnel",
  "eduflow.blockEditor.mindmap.playerHint": "Au lecteur : carte horizontale (texte sur trait coloré, courbes, pastilles). Zoom dans l’en-tête du bloc. URL : icône ↗ (nouvel onglet).",
  "eduflow.blockEditor.mindmap.remove": "Supprimer",
  "eduflow.blockEditor.mindmap.structure": "Structure",
  "eduflow.blockEditor.mindmap.subtitleLabel": "Sous-titre",
  "eduflow.blockEditor.mindmap.titleLabel": "Titre",
  "eduflow.blockEditor.mindmap.titlePlaceholder": "Titre du nœud",
  "eduflow.blockEditor.mindmap.untitled": "Sans titre",
  "eduflow.blockEditor.mindmap.urlLabel": "Lien URL",
  "eduflow.blockEditor.mindmap.urlPlaceholder": "https://…",
  "eduflow.blockEditor.pdf.allowDownload": "Autoriser le téléchargement",
  "eduflow.blockEditor.pdf.badgePdf": "PDF",
  "eduflow.blockEditor.pdf.completionLabel": "Texte de validation",
  "eduflow.blockEditor.pdf.completionPlaceholder": "Document consulté",
  "eduflow.blockEditor.pdf.documentFallback": "Document PDF",
  "eduflow.blockEditor.pdf.emptyLibrary": "Aucun document dans votre bibliothèque.",
  "eduflow.blockEditor.pdf.focusMode": "Focus document",
  "eduflow.blockEditor.pdf.focusModeDesc": "Chrome allégé, lecture centrée",
  "eduflow.blockEditor.pdf.importFailed": "Import impossible",
  "eduflow.blockEditor.pdf.importFailedGeneric": "L'import a échoué.",
  "eduflow.blockEditor.pdf.importSubtitle": "Le document sera ajouté à votre bibliothèque documents.",
  "eduflow.blockEditor.pdf.importTitle": "Importer un PDF",
  "eduflow.blockEditor.pdf.librarySubtitle": "Importez un PDF dans votre bibliothèque ou sélectionnez-en un existant.",
  "eduflow.blockEditor.pdf.libraryTitle": "Bibliothèque documents",
  "eduflow.blockEditor.pdf.loadingDocs": "Chargement des documents…",
  "eduflow.blockEditor.pdf.myDocuments": "Mes documents",
  "eduflow.blockEditor.pdf.pagesAuto": "Le lecteur détectera automatiquement le nombre de pages.",
  "eduflow.blockEditor.pdf.pagesDetected": "{{count}} pages détectées",
  "eduflow.blockEditor.pdf.pickFromLibrary": "Sélectionnez un PDF déjà importé dans votre bibliothèque.",
  "eduflow.blockEditor.pdf.previewTitle": "Aperçu du document",
  "eduflow.blockEditor.pdf.readerMode": "Lecteur moderne",
  "eduflow.blockEditor.pdf.readerModeDesc": "Page par page, zoom, plein écran",
  "eduflow.blockEditor.pdf.readingExperience": "Expérience de lecture",
  "eduflow.blockEditor.pdf.showProgress": "Afficher la progression de lecture",
  "eduflow.blockEditor.pdf.smartExtractSoon": "Extraction intelligente bientôt",
  "eduflow.blockEditor.pdf.startPage": "Page de départ",
  "eduflow.blockEditor.pdf.uploadedDesc": "{{name}} est maintenant disponible dans votre bibliothèque documents.",
  "eduflow.blockEditor.pdf.uploadedToast": "PDF importé",
  "eduflow.blockEditor.pdf.uploading": "Upload en cours",
  "eduflow.blockEditor.phraseReveal.addPhrase": "Ajouter une phrase",
  "eduflow.blockEditor.phraseReveal.aiSummaryTitle": "Générer un récapitulatif IA depuis les blocs en amont",
  "eduflow.blockEditor.phraseReveal.autoScroll": "Défilement automatique",
  "eduflow.blockEditor.phraseReveal.displayDuration": "Durée par phrase (s)",
  "eduflow.blockEditor.phraseReveal.editorHint": "Ajoutez une ou plusieurs phrases avec l’éditeur enrichi. Le lecteur affiche une phrase à la fois ; clic ou Espace pour la suivante.",
  "eduflow.blockEditor.phraseReveal.emptyPhrase": "Phrase vide",
  "eduflow.blockEditor.phraseReveal.importLegacy": "Importer l’ancien champ « Texte à révéler » en phrases (recommandé).",
  "eduflow.blockEditor.phraseReveal.noPhrases": "Aucune phrase pour l’instant.",
  "eduflow.blockEditor.phraseReveal.phraseContent": "Contenu de la phrase",
  "eduflow.blockEditor.phraseReveal.phrasePlaceholder": "Saisissez le texte de cette étape…",
  "eduflow.blockEditor.phraseReveal.showHistory": "Afficher l’historique des phrases",
  "eduflow.blockEditor.phraseReveal.showHistoryHelp": "Les phrases déjà vues s’affichent dans une carte entre la phrase en cours et la description du bloc.",
  "eduflow.blockEditor.presentation.addSlide": "Diapositive",
  "eduflow.blockEditor.presentation.autoAdvance": "Avance automatique",
  "eduflow.blockEditor.presentation.delayLabel": "Délai : {{sec}}s",
  "eduflow.blockEditor.presentation.duplicateTitleSuffix": " (copie)",
  "eduflow.blockEditor.presentation.globalSettings": "Paramètres globaux",
  "eduflow.blockEditor.presentation.layoutImageText": "Image + texte",
  "eduflow.blockEditor.presentation.layoutTitleContent": "Titre + contenu",
  "eduflow.blockEditor.presentation.layoutTitleOnly": "Titre seul",
  "eduflow.blockEditor.presentation.layoutTwoCol": "Deux colonnes",
  "eduflow.blockEditor.presentation.layoutVideoOnly": "Vidéo seul",
  "eduflow.blockEditor.presentation.layoutVideoText": "Texte + vidéo",
  "eduflow.blockEditor.presentation.loop": "Boucle",
  "eduflow.blockEditor.presentation.noSlides": "Aucune diapositive. Cliquez pour en ajouter.",
  "eduflow.blockEditor.presentation.slideCount_one": "{{count}} diapositive",
  "eduflow.blockEditor.presentation.slideCount_other": "{{count}} diapositives",
  "eduflow.blockEditor.presentation.slideNumbers": "Numéros de diapositives",
  "eduflow.blockEditor.presentation.slidesHeading": "Diapositives",
  "eduflow.blockEditor.presentation.transition": "Transition",
  "eduflow.blockEditor.presentation.transitionFade": "Fondu",
  "eduflow.blockEditor.presentation.transitionNone": "Aucune",
  "eduflow.blockEditor.presentation.transitionSlide": "Glissement",
  "eduflow.blockEditor.presentation.transitionZoom": "Zoom",
  "eduflow.blockEditor.quiz.addAnswer": "Ajouter une réponse",
  "eduflow.blockEditor.quiz.addOrderingItem": "Ajouter un élément",
  "eduflow.blockEditor.quiz.aiMcqTitle": "Générer un QCM par IA à partir des blocs en amont",
  "eduflow.blockEditor.quiz.answerPlaceholder": "Réponse {{n}}",
  "eduflow.blockEditor.quiz.answersCount": "Réponses ({{count}}/10)",
  "eduflow.blockEditor.quiz.branching": "Branchement",
  "eduflow.blockEditor.quiz.correctAnswer": "Bonne réponse",
  "eduflow.blockEditor.quiz.correctAnswerPlaceholder": "Sélectionner…",
  "eduflow.blockEditor.quiz.explanation": "Explication",
  "eduflow.blockEditor.quiz.explanationPlaceholder": "Explication complémentaire...",
  "eduflow.blockEditor.quiz.false": "Faux",
  "eduflow.blockEditor.quiz.feedback": "Feedback",
  "eduflow.blockEditor.quiz.ifCorrect": "Si correct →",
  "eduflow.blockEditor.quiz.ifIncorrect": "Si incorrect →",
  "eduflow.blockEditor.quiz.markAsCorrect": "Marquer comme correcte",
  "eduflow.blockEditor.quiz.markCorrect": "Réponse correcte",
  "eduflow.blockEditor.quiz.msgCorrect": "Message si correct",
  "eduflow.blockEditor.quiz.msgCorrectPlaceholder": "Bravo ! C'est la bonne réponse.",
  "eduflow.blockEditor.quiz.msgIncorrect": "Message si incorrect",
  "eduflow.blockEditor.quiz.msgIncorrectPlaceholder": "Ce n'est pas la bonne réponse.",
  "eduflow.blockEditor.quiz.nextBlockAuto": "Bloc suivant (auto)",
  "eduflow.blockEditor.quiz.orderingHint": "Éléments à ordonner (l’ordre actuel = ordre correct)",
  "eduflow.blockEditor.quiz.orderingItemPlaceholder": "Élément {{n}}",
  "eduflow.blockEditor.quiz.partialScoring": "Score partiel (QCM)",
  "eduflow.blockEditor.quiz.question": "Question",
  "eduflow.blockEditor.quiz.questionPlaceholder": "Saisissez votre question...",
  "eduflow.blockEditor.quiz.quizType": "Type de quiz",
  "eduflow.blockEditor.quiz.score": "Score",
  "eduflow.blockEditor.quiz.showCorrect": "Afficher la réponse correcte",
  "eduflow.blockEditor.quiz.shuffle": "Mélanger",
  "eduflow.blockEditor.quiz.true": "Vrai",
  "eduflow.blockEditor.quiz.typeMcq": "QCM",
  "eduflow.blockEditor.quiz.typeFillBlank": "Texte à trous",
  "eduflow.blockEditor.quiz.typeOrdering": "Classement",
  "eduflow.blockEditor.quiz.typeTrueFalse": "Vrai / Faux",
  "eduflow.blockEditor.quiz.branchingMode": "Mode de branchement",
  "eduflow.blockEditor.quiz.branchingNone": "Aucun (linéaire)",
  "eduflow.blockEditor.quiz.branchingCorrectIncorrect": "Correct / Incorrect",
  "eduflow.blockEditor.quiz.branchingPerAnswer": "Par réponse individuelle",
  "eduflow.blockEditor.loop.maxIterationsLabel": "Nombre maximum d'itérations (0 = infini)",
  "eduflow.blockEditor.loop.infiniteHint": "La boucle continuera indéfiniment jusqu'à ce que la condition soit remplie.",
  "eduflow.blockEditor.loop.limitedHint": "La boucle s'arrêtera après {{count}} tentative(s) maximum.",
  "eduflow.blockEditor.loop.howItWorksTitle": "Comment ça fonctionne :",
  "eduflow.blockEditor.loop.howItWorksText": "La boucle redirigera l'utilisateur vers le bloc connecté sur la sortie « Boucle » tant que la condition n'est pas remplie (nombre max d'itérations : 0 = infini). Utilisez la sortie « Fin » pour la suite du parcours.",
  "eduflow.blockEditor.selfAssessment.addBadge": "Ajouter",
  "eduflow.blockEditor.selfAssessment.addCriterion": "Ajouter",
  "eduflow.blockEditor.selfAssessment.badgeInputPlaceholder": "Ex. Souvent, Jamais, Parfois…",
  "eduflow.blockEditor.selfAssessment.badgeOptionsHint": "Mots ou courtes expressions : l’apprenant les choisit comme pastilles. Sans proposition → champ texte libre.",
  "eduflow.blockEditor.selfAssessment.badgeOptionsLabel": "Propositions (badges)",
  "eduflow.blockEditor.selfAssessment.criteriaSection": "Critères",
  "eduflow.blockEditor.selfAssessment.criterionDescription": "Description (optionnelle)",
  "eduflow.blockEditor.selfAssessment.criterionDescriptionPh": "Précisez ce que l’apprenant doit observer ou comment se positionner…",
  "eduflow.blockEditor.selfAssessment.criterionTitle": "Intitulé",
  "eduflow.blockEditor.selfAssessment.criterionTitlePh": "Ex. Communication, Autonomie…",
  "eduflow.blockEditor.selfAssessment.emptyCriteria": "Aucun critère. Ajoutez au moins une ligne pour que l’apprenant puisse s’auto-évaluer.",
  "eduflow.blockEditor.selfAssessment.moveDown": "Descendre",
  "eduflow.blockEditor.selfAssessment.moveUp": "Monter",
  "eduflow.blockEditor.selfAssessment.panelHint": "Définissez chaque dimension à noter : intitulé court et, si besoin, une description pour guider l’apprenant.",
  "eduflow.blockEditor.selfAssessment.panelTitle": "Auto-évaluation",
  "eduflow.blockEditor.selfAssessment.removeBadge": "Retirer",
  "eduflow.blockEditor.selfAssessment.removeCriterion": "Supprimer ce critère",
  "eduflow.blockEditor.selfAssessment.responseTypeLabel": "Type de réponse",
  "eduflow.blockEditor.selfAssessment.scaleHint": "De 1 à N (ex. 5 = Likert)",
  "eduflow.blockEditor.selfAssessment.scaleLabel": "Échelle de notation",
  "eduflow.blockEditor.selfAssessment.starCountHint": "Souvent 5",
  "eduflow.blockEditor.selfAssessment.starCountLabel": "Nombre d’étoiles",
  "eduflow.blockEditor.selfAssessment.textModeHint": "Par critère : ajoutez des propositions en badges (sélection) ou laissez vide pour une réponse rédigée. Le commentaire global reste sous les critères au lecteur.",
  "eduflow.blockEditor.selfAssessment.typeNumeric": "Chiffres",
  "eduflow.blockEditor.selfAssessment.typeNumericHint": "Boutons 1 à N",
  "eduflow.blockEditor.selfAssessment.typeStars": "Étoiles",
  "eduflow.blockEditor.selfAssessment.typeStarsHint": "Notation visuelle",
  "eduflow.blockEditor.selfAssessment.typeText": "Texte libre",
  "eduflow.blockEditor.selfAssessment.typeTextHint": "Réponse rédigée par critère",
  "eduflow.blockEditor.shared.alignCenter": "Centrer",
  "eduflow.blockEditor.shared.alignLeft": "Aligner à gauche",
  "eduflow.blockEditor.shared.alignRight": "Aligner à droite",
  "eduflow.blockEditor.shared.annotationCount_one": "{{count}} annotation",
  "eduflow.blockEditor.shared.annotationCount_other": "{{count}} annotations",
  "eduflow.blockEditor.shared.blocksCount": "{{count}} blocs",
  "eduflow.blockEditor.shared.bold": "Gras",
  "eduflow.blockEditor.shared.border": "Bordure",
  "eduflow.blockEditor.shared.bulletList": "Liste à puces",
  "eduflow.blockEditor.shared.cancel": "Annuler",
  "eduflow.blockEditor.shared.choose": "Choisir",
  "eduflow.blockEditor.shared.close": "Fermer",
  "eduflow.blockEditor.shared.configure": "Configurer",
  "eduflow.blockEditor.shared.delete": "Supprimer",
  "eduflow.blockEditor.shared.duplicate": "Dupliquer",
  "eduflow.blockEditor.shared.imageLabel": "Image",
  "eduflow.blockEditor.shared.italic": "Italique",
  "eduflow.blockEditor.shared.layoutPrefix": "Layout : ",
  "eduflow.blockEditor.shared.linked": "Lié",
  "eduflow.blockEditor.shared.maxAttempts": "Tentatives max",
  "eduflow.blockEditor.shared.mediaImage": " Image",
  "eduflow.blockEditor.shared.mediaNone": " Pas de média",
  "eduflow.blockEditor.shared.mediaVideo": " Vidéo",
  "eduflow.blockEditor.shared.minutes": "Minutes",
  "eduflow.blockEditor.shared.noImage": "Aucune image",
  "eduflow.blockEditor.shared.numberedList": "Liste numérotée",
  "eduflow.blockEditor.shared.option": "Option",
  "eduflow.blockEditor.shared.pages": "{{count}} pages",
  "eduflow.blockEditor.shared.points": "Points",
  "eduflow.blockEditor.shared.retry": "Réessayer",
  "eduflow.blockEditor.shared.rounded": "Coins arrondis",
  "eduflow.blockEditor.shared.save": "Enregistrer",
  "eduflow.blockEditor.shared.selected": "Sélectionné",
  "eduflow.blockEditor.shared.shadow": "Ombre",
  "eduflow.blockEditor.shared.slideCounter": "Slide {{index}}/{{total}}",
  "eduflow.blockEditor.shared.speedTicks": "{{v}}x",
  "eduflow.blockEditor.shared.strike": "Barré",
  "eduflow.blockEditor.shared.underline": "Souligné",
  "eduflow.blockEditor.shared.untitledSlide": "Sans titre",
  "eduflow.blockEditor.shared.updatedOn": "Mis à jour {{date}}",
  "eduflow.blockEditor.subflow.emptyPublished": "Aucune formation publiée disponible",
  "eduflow.blockEditor.subflow.emptySearch": "Aucune formation trouvée",
  "eduflow.blockEditor.subflow.linkedTraining": "Sous-formation liée",
  "eduflow.blockEditor.subflow.loadError": "Impossible de charger les formations",
  "eduflow.blockEditor.subflow.loading": "Chargement…",
  "eduflow.blockEditor.subflow.openInTab": "Ouvrir la sous-formation dans un nouvel onglet",
  "eduflow.blockEditor.subflow.remove": "Retirer",
  "eduflow.blockEditor.subflow.searchPlaceholder": "Rechercher une formation publiée…",
  "eduflow.blockEditor.summary.addItem": "Ajouter un point",
  "eduflow.blockEditor.summary.aiRecapTitle": "Générer un récapitulatif IA depuis les blocs en amont",
  "eduflow.blockEditor.summary.editorHint": "Liste les notions ou étapes vues dans la formation. Chaque ligne apparaît comme une puce dans le lecteur.",
  "eduflow.blockEditor.summary.emptyList": "Aucun point pour l’instant. Ajoutez-en un.",
  "eduflow.blockEditor.summary.itemPlaceholder": "Ex. : Les risques incendie en entreprise",
  "eduflow.blockEditor.text.audioTts": "Audio (TTS)",
  "eduflow.blockEditor.text.charWordCount": "{{chars}} caractères · {{words}} mots",
  "eduflow.blockEditor.text.content": "Contenu",
  "eduflow.blockEditor.text.contentPlaceholder": "Saisissez le contenu du bloc texte…",
  "eduflow.blockEditor.text.formatting": "Mise en forme",
  "eduflow.blockEditor.text.headingH1": "Titre 1",
  "eduflow.blockEditor.text.headingH2": "Titre 2",
  "eduflow.blockEditor.text.headingH3": "Titre 3",
  "eduflow.blockEditor.text.headingH4": "Titre 4",
  "eduflow.blockEditor.text.headingH5": "Titre 5",
  "eduflow.blockEditor.text.headingH6": "Titre 6",
  "eduflow.blockEditor.text.headingLevel": "Niveau de titre",
  "eduflow.blockEditor.text.headingParagraph": "Paragraphe",
  "eduflow.blockEditor.text.previewSoon": "Prévisualiser (bientôt)",
  "eduflow.blockEditor.text.readTime": "~{{min}} min de lecture",
  "eduflow.blockEditor.text.speedLabel": "Vitesse : {{speed}}x",
  "eduflow.blockEditor.text.voice": "Voix",
  "eduflow.blockEditor.text.voiceAdam": "Adam (FR masculin)",
  "eduflow.blockEditor.text.voiceBella": "Bella (FR féminin)",
  "eduflow.blockEditor.text.voiceHeart": "Heart (FR féminin)",
  "eduflow.blockEditor.text.voiceMichael": "Michael (EN masculin)",
  "eduflow.blockEditor.text.voiceNova": "Nova (EN féminin)",
  "eduflow.blockEditor.text.voiceSky": "Sky (EN féminin)",
  "eduflow.blockEditor.timeline.addEvent": "Événement",
  "eduflow.blockEditor.timeline.alternatingSides": "Côtés alternés",
  "eduflow.blockEditor.timeline.animatedReveal": "Révélation animée",
  "eduflow.blockEditor.timeline.colorHint": "Couleur du point (optionnel)",
  "eduflow.blockEditor.timeline.colorLabel": "Couleur",
  "eduflow.blockEditor.timeline.datePlaceholder": "Date ou période (ex. 1789, janv. 2024)",
  "eduflow.blockEditor.timeline.descPlaceholder": "Description (affichée au développement)",
  "eduflow.blockEditor.timeline.emptyEvents": "Aucun événement. Ajoutez-en un pour construire la frise.",
  "eduflow.blockEditor.timeline.events": "Événements",
  "eduflow.blockEditor.timeline.horizontal": "Horizontale",
  "eduflow.blockEditor.timeline.iconAward": "Médaille",
  "eduflow.blockEditor.timeline.iconCheck": "Validation",
  "eduflow.blockEditor.timeline.iconClock": "Horloge",
  "eduflow.blockEditor.timeline.iconFlag": "Drapeau",
  "eduflow.blockEditor.timeline.iconStar": "Étoile",
  "eduflow.blockEditor.timeline.moveDown": "Descendre",
  "eduflow.blockEditor.timeline.moveUp": "Monter",
  "eduflow.blockEditor.timeline.orientation": "Orientation",
  "eduflow.blockEditor.timeline.settings": "Paramètres",
  "eduflow.blockEditor.timeline.showConnectors": "Lignes de connexion",
  "eduflow.blockEditor.timeline.titlePlaceholder": "Titre de l'événement",
  "eduflow.blockEditor.timeline.untitled": "Sans titre",
  "eduflow.blockEditor.timeline.vertical": "Verticale",
  "eduflow.blockEditor.videoSubtitles.cancel": "Annuler",
  "eduflow.blockEditor.videoSubtitles.invalidResponse": "Réponse invalide du serveur.",
  "eduflow.blockEditor.videoSubtitles.invalidUrl": "URL de piste invalide.",
  "eduflow.blockEditor.videoSubtitles.loadError": "Chargement impossible.",
  "eduflow.blockEditor.videoSubtitles.loadFailed": "Impossible de charger la piste ({{status}}).",
  "eduflow.blockEditor.videoSubtitles.loading": "Chargement des segments…",
  "eduflow.blockEditor.videoSubtitles.modalSubtitle": "Un bloc par apparition à l’écran. Les horaires sont conservés ; seul le texte est modifiable.",
  "eduflow.blockEditor.videoSubtitles.modalTitle": "Éditer les sous-titres",
  "eduflow.blockEditor.videoSubtitles.noSegments": "Aucun segment lisible dans le fichier sous-titres.",
  "eduflow.blockEditor.videoSubtitles.saveFailed": "Enregistrement impossible.",
  "eduflow.blockEditor.videoSubtitles.saveTrack": "Enregistrer la piste",
  "eduflow.blockEditor.videoSubtitles.savedToast": "Sous-titres enregistrés",
  "eduflow.blockEditor.videoSubtitles.segmentN": "Segment {{n}}",
  "eduflow.blockEditor.videoSubtitles.segmentRequiredToast": "Au moins un segment avec du texte est requis.",
  "eduflow.blockEditor.videoSubtitles.trackLang": "Langue piste : {{label}}",
  "eduflow.blockEditor.video.autoCaptionBullet": "Extraction audio (ffmpeg) puis transcription Mistral. URL directe .mp4 recommandée ; pas de page YouTube.",
  "eduflow.blockEditor.video.autoCaptionErrorFallback": "Vérifiez la clé Mistral, ffmpeg sur le serveur et que la vidéo contient de l’audio.",
  "eduflow.blockEditor.video.autoCaptionSection": "Sous-titres automatiques",
  "eduflow.blockEditor.video.autoCaptionsButton": "Générer sous-titres (audio + IA)",
  "eduflow.blockEditor.video.availableSubtitlesChip": "Sous-titres disponibles",
  "eduflow.blockEditor.video.completionThreshold": "Seuil de complétion (%)",
  "eduflow.blockEditor.video.editCueButton": "Modifier les sous-titres (par segment)",
  "eduflow.blockEditor.video.endSeconds": "Fin (sec)",
  "eduflow.blockEditor.video.escHint": "Esc pour fermer",
  "eduflow.blockEditor.video.libraryEmpty": "Aucune vidéo disponible dans votre bibliothèque.",
  "eduflow.blockEditor.video.libraryTitle": "Bibliothèque vidéos",
  "eduflow.blockEditor.video.libraryHint": "Sélectionnez une vidéo déjà importée dans votre dashboard concepteur.",
  "eduflow.blockEditor.video.libraryLoading": "Chargement des vidéos…",
  "eduflow.blockEditor.video.optionalEnd": "Optionnel",
  "eduflow.blockEditor.video.accent.primary": "Primaire",
  "eduflow.blockEditor.video.aspectFormat": "Format",
  "eduflow.blockEditor.video.aspect.ratio169": "16:9",
  "eduflow.blockEditor.video.aspect.ratio219": "21:9",
  "eduflow.blockEditor.video.aspect.ratio43": "4:3",
  "eduflow.blockEditor.video.aspect.ratio11": "1:1",
  "eduflow.blockEditor.video.pickFromLibrary": "Choisir",
  "eduflow.blockEditor.video.playerBadge": "Player vidéo",
  "eduflow.blockEditor.video.previewTitleFallback": "Lecteur vidéo",
  "eduflow.blockEditor.video.reduced": "Réduire",
  "eduflow.blockEditor.video.regenerateCaptions": "Regénérer",
  "eduflow.blockEditor.video.previewHint": "Upload, YouTube ou URL directe avec design personnalisable.",
  "eduflow.blockEditor.video.previewIframeTitle": "Prévisualisation vidéo",
  "eduflow.blockEditor.video.subtitleBadge": "Sous-titres",
  "eduflow.blockEditor.video.selected": "Sélectionnée",
  "eduflow.blockEditor.video.designTab": "Design",
  "eduflow.blockEditor.video.radius.soft": "Légers",
  "eduflow.blockEditor.video.radius.rounded": "Arrondis",
  "eduflow.blockEditor.video.radius.square": "Carrés",
  "eduflow.blockEditor.video.shadow.soft": "Douce",
  "eduflow.blockEditor.video.shadow.glow": "Lueur",
  "eduflow.blockEditor.video.shadow.dramatic": "Dramatique",
  "eduflow.blockEditor.video.shadowLabel": "Ombre",
  "eduflow.blockEditor.video.radiusCornerLabel": "Coins",
  "eduflow.blockEditor.video.themeEditorial.desc": "Clair, propre, institutionnel",
  "eduflow.blockEditor.video.themeEditorial.label": "Editorial",
  "eduflow.blockEditor.video.themeCinema.desc": "Sombre, premium, immersif",
  "eduflow.blockEditor.video.themeCinema.label": "Cinéma",
  "eduflow.blockEditor.video.themeGlass.desc": "Translucide, moderne, lumineux",
  "eduflow.blockEditor.video.themeGlass.label": "Glass",
  "eduflow.blockEditor.video.themeApp.desc": "Par défaut, aligné avec le thème actuel",
  "eduflow.blockEditor.video.themeApp.label": "Application",
  "eduflow.blockEditor.video.themeAccent": "Couleur d’accent",
  "eduflow.blockEditor.video.themePlayer": "Thème du player",
  "eduflow.blockEditor.video.toast.autoCaptionsError": "Sous-titres automatiques indisponibles",
  "eduflow.blockEditor.video.toast.autoCaptionsOk": "Sous-titres générés",
  "eduflow.blockEditor.video.toast.autoCaptionsOkDesc": "Ils s’affichent en temps réel pendant la lecture dans le player.",
  "eduflow.blockEditor.video.toast.uploadErrorDesc": "L’import a échoué.",
  "eduflow.blockEditor.video.toast.uploadErrorTitle": "Import impossible",
  "eduflow.blockEditor.video.toast.uploadedDesc": "{{name}} est prête dans votre bloc vidéo.",
  "eduflow.blockEditor.video.toast.uploadedTitle": "Vidéo importée",
  "eduflow.blockEditor.video.fullscreenExpandTitle": "Ouvrir en plein écran",
  "eduflow.blockEditor.video.fullscreenHeading": "Bloc vidéo",
  "eduflow.blockEditor.video.importDragTitle": "Importer une vidéo",
  "eduflow.blockEditor.video.importFormats": "MP4, WebM, OGG, MOV · max {{maxMb}} MB côté UI",
  "eduflow.blockEditor.video.noneSelected": "Aucune vidéo sélectionnée",
  "eduflow.blockEditor.video.playbackTab": "Lecture",
  "eduflow.blockEditor.video.playbackSettingsTitle": "Paramètres de lecture",
  "eduflow.blockEditor.video.loop": "Boucle",
  "eduflow.blockEditor.video.autoplay": "Lecture automatique",
  "eduflow.blockEditor.video.mutedStart": "Muet au démarrage",
  "eduflow.blockEditor.video.showControls": "Afficher les contrôles",
  "eduflow.blockEditor.video.embedSubtitlesYoutubeVimeo": "Sur {{platform}}, activez les sous-titres dans le lecteur intégré (CC). Le player charge les pistes fournies par la plateforme.",
  "eduflow.blockEditor.video.trackReadyHint": "Piste WebVTT prête : dans le lecteur, affichage dans la langue choisie par l’apprenant (les 12 langues du player ; traduction à la volée si besoin).",
  "eduflow.blockEditor.video.langTranscriptionTrack": "Langue (transcription / piste source)",
  "eduflow.blockEditor.video.placeholderUrlGeneric": "https://example.com/video.mp4",
  "eduflow.blockEditor.video.placeholderVimeo": "https://vimeo.com/…",
  "eduflow.blockEditor.video.placeholderYoutube": "https://www.youtube.com/watch?v=…",
  "eduflow.blockEditor.video.invalidUrlSource": "URL invalide pour cette source",
  "eduflow.blockEditor.video.urlHelpDirect": "Compatible avec les URLs directes vers un fichier vidéo.",
  "eduflow.blockEditor.video.labelUrlGeneric": "URL de la vidéo",
  "eduflow.blockEditor.video.labelUrlVimeo": "URL Vimeo",
  "eduflow.blockEditor.video.labelUrlYoutube": "URL YouTube",
  "eduflow.blockEditor.video.readyInBlock": "Vidéo prête dans le bloc",
  "eduflow.blockEditor.video.uploadInProgress": "Upload en cours",
  "eduflow.blockEditor.video.sectionSubtitlesDesign": "Sous-titres",
  "eduflow.blockEditor.video.sourceLabel": "Source vidéo",
  "eduflow.blockEditor.video.sourceTab": "Source",
  "eduflow.blockEditor.video.sourceUrl": "URL",
  "eduflow.blockEditor.video.sourceUpload": "Fichier",
  "eduflow.blockEditor.video.startSeconds": "Début (sec)",
  "eduflow.blockEditor.video.showPlayerHeader": "Afficher l’en-tête du player",
  "eduflow.blockEditor.video.accent.amber": "Ambre",
  "eduflow.blockEditor.video.accent.emerald": "Émeraude",
  "eduflow.blockEditor.richText.collapsedHintHtml": "Réduire l’éditeur (mode HTML actif)",
  "eduflow.blockEditor.richText.collapsedHintReopen": "Cliquer pour rouvrir l’éditeur",
  "eduflow.blockEditor.richText.defaultPlaceholder": "Écrivez votre contenu ici…",
  "eduflow.blockEditor.richText.slashPlaceholder": "Commencez à écrire ou tapez « / » pour les commandes",
  "eduflow.blockEditor.richText.slashButtonDefaultLabel": "Bouton",
  "eduflow.blockEditor.richText.slash.empty": "Aucune commande correspondante",
  "eduflow.blockEditor.richText.slash.menuLabel": "Commandes de mise en forme",
  "eduflow.blockEditor.richText.slash.sectionBasic": "Basique",
  "eduflow.blockEditor.richText.slash.sectionFormFields": "Champs formulaire",
  "eduflow.blockEditor.richText.slash.helpMeWrite": "Aidez-moi à écrire",
  "eduflow.blockEditor.richText.slash.helpMeWriteKeywords": "ia ai assistant rédaction",
  "eduflow.blockEditor.richText.slash.paragraph": "Paragraphe",
  "eduflow.blockEditor.richText.slash.paragraphKeywords": "texte normal",
  "eduflow.blockEditor.richText.slash.heading2": "Titre 2",
  "eduflow.blockEditor.richText.slash.heading2Keywords": "h2 sous-titre",
  "eduflow.blockEditor.richText.slash.heading3": "Titre 3",
  "eduflow.blockEditor.richText.slash.heading3Keywords": "h3",
  "eduflow.blockEditor.richText.slash.orderedList": "Liste numérotée",
  "eduflow.blockEditor.richText.slash.orderedListKeywords": "numéros 1 2 3",
  "eduflow.blockEditor.richText.slash.bulletList": "Liste à puces",
  "eduflow.blockEditor.richText.slash.bulletListKeywords": "puces points",
  "eduflow.blockEditor.richText.slash.blockquote": "Citation",
  "eduflow.blockEditor.richText.slash.blockquoteKeywords": "quote guillemets",
  "eduflow.blockEditor.richText.slash.divider": "Séparateur",
  "eduflow.blockEditor.richText.slash.dividerKeywords": "ligne hr trait",
  "eduflow.blockEditor.richText.slash.code": "Code",
  "eduflow.blockEditor.richText.slash.codeKeywords": "bloc snippet",
  "eduflow.blockEditor.richText.slash.emoji": "Émoji",
  "eduflow.blockEditor.richText.slash.emojiKeywords": "smiley emoticon",
  "eduflow.blockEditor.richText.slash.button": "Bouton",
  "eduflow.blockEditor.richText.slash.buttonKeywords": "lien cta action",
  "eduflow.blockEditor.richText.fullscreenTitleFallback": "Éditeur",
  "eduflow.blockEditor.richText.calloutBody": "Votre texte ici…",
  "eduflow.blockEditor.richText.calloutTitle": "Titre de l’encart",
  "eduflow.blockEditor.richText.fullscreen": "Plein écran",
  "eduflow.blockEditor.richText.highlight": "Surligner",
  "eduflow.blockEditor.richText.imageTab": "Image",
  "eduflow.blockEditor.richText.importTab": "Importer",
  "eduflow.blockEditor.richText.infoPanelBody": "Ajoutez une information clé pour l’apprenant.",
  "eduflow.blockEditor.richText.infoPanelTitle": "Bon à savoir",
  "eduflow.blockEditor.richText.inlineCode": "Code inline",
  "eduflow.blockEditor.richText.insertBadge": "Badge",
  "eduflow.blockEditor.richText.insertCallout": "Encart",
  "eduflow.blockEditor.richText.insertCalloutCompact": "Insérer un encart",
  "eduflow.blockEditor.richText.insertImage": "Insérer une image",
  "eduflow.blockEditor.richText.insertImageAction": "Insérer l’image",
  "eduflow.blockEditor.richText.insertInfoPanel": "Panneau info",
  "eduflow.blockEditor.richText.insertVideo": "Insérer une vidéo",
  "eduflow.blockEditor.richText.insertVideoAction": "Insérer la vidéo",
  "eduflow.blockEditor.richText.libraryTab": "Mes images",
  "eduflow.blockEditor.richText.link": "Lien",
  "eduflow.blockEditor.richText.linkOk": "OK",
  "eduflow.blockEditor.richText.linkPlaceholderHttps": "https://…",
  "eduflow.blockEditor.richText.linkPrompt": "URL du lien :",
  "eduflow.blockEditor.richText.mediaFormatsHint": "PNG, JPG, GIF, WebP · max 10 Mo",
  "eduflow.blockEditor.richText.minimizeToolbar": "Réduire",
  "eduflow.blockEditor.richText.modalLibraryEmpty": "Aucune image dans votre bibliothèque",
  "eduflow.blockEditor.richText.modalUploading": "Envoi en cours…",
  "eduflow.blockEditor.richText.openImportTab": "Importer une image",
  "eduflow.blockEditor.richText.placeholderImageUrl": "https://exemple.com/image.jpg",
  "eduflow.blockEditor.richText.placeholderYoutube": "https://youtube.com/watch?v=…",
  "eduflow.blockEditor.richText.quote": "Citation",
  "eduflow.blockEditor.richText.redo": "Refaire",
  "eduflow.blockEditor.richText.separatorRule": "Séparateur",
  "eduflow.blockEditor.richText.showHtmlSource": "Afficher / modifier le HTML",
  "eduflow.blockEditor.richText.returnToVisual": "Revenir à l’éditeur visuel",
  "eduflow.blockEditor.richText.tplBadgeLabel": "Badge",
  "eduflow.blockEditor.richText.uploadDropPrompt": "Glisser-déposer ou",
  "eduflow.blockEditor.richText.uploadDropClick": "cliquer pour sélectionner",
  "eduflow.blockEditor.richText.heading1": "Titre 1",
  "eduflow.blockEditor.richText.heading2": "Titre 2",
  "eduflow.blockEditor.richText.heading3": "Titre 3",
  "eduflow.blockEditor.richText.justify": "Justifier",
  "eduflow.blockEditor.richText.undo": "Annuler",
  "eduflow.blockEditor.richText.videoYoutubePaste": "Coller l’URL YouTube ci-dessous",
  "eduflow.blockEditor.richText.videoYoutubeToolbar": "Vidéo YouTube",
  "eduflow.blockEditor.richText.urlTab": "URL"
};
